<template>
<div class="questionary_accordion template_view" v-if="qloaded">
  <div >
    <div class="block_title">
      Questionnaire Details
    </div> 
    <div class="block-layout">
        <div :before-change="beforeTabSwitch" class=" wizard-container questionnaireeditor questionnairesection form_section pad0">
        <!-- tab 1 content -->
        <form data-vv-scope="beneficiaryInfoform" @submit.prevent="" @keydown.enter.prevent=""> 
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" v-if="false">
                <div class="form-container">
                  <div class="vx-row">
                    <!----
                       immPetitionPriorityDate: false, // list your Priority Date obtained from your previous immigrant petition

          applyI485AdjOrConsuProcess: false, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },

          adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },

          consularProcessing:false,// Consular Processing { type: Boolean, default: false },

          areYouUnderRemoveOfIndOrUscis: false, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },


                      ---->

                      <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('immPetitionPriorityDate')" >
                      <div class="form_group ">
                        <label class="form_label">list your Priority Date obtained from your previous immigrant petition</label>
                        <div class="main-placeholder right">
                          <datepicker  :typeable="true" name="immPetitionPriorityDate" 
                          :open-date="new Date(startEligibleDate)"
                          :disabled-dates="{from: new Date(startEligibleDate)}" data-vv-as="Date of Birth"
                            v-model="beneficiaryInfo.immPetitionPriorityDate"   placeholder="MM/DD/YYYY">
                          </datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.immPetitionPriorityDate')">{{ errors.first("beneficiaryInfoform.immPetitionPriorityDate") }}</span>
                        </div>
                      </div>

                      
                    </div>
                      

                    <div class="vx-col md:w-1/2 w-full martb10 " v-if="checkTemplateField('applyI485AdjOrConsuProcess')">
                      <div class="main-placeholder right">
                        <!-- applyI485AdjOrConsuProcess -->
                        <vs-checkbox name="applyI485AdjOrConsuProcess"
                          
                          v-model="beneficiary.applyI485AdjOrConsuProcess" class="w-full" label="">Would you like to apply for adjustment of status (I-485) or consular processing?
                        </vs-checkbox>

                      </div>

                    </div>

                    <div class="vx-col md:w-1/2 w-full martb10 " v-if="checkTemplateField('applyI485AdjOrConsuProcess')">
                      <div class="main-placeholder right">
                        <!-- adjustmentOfI485Status -->
                        <vs-checkbox name="adjustmentOfI485Status"
                          
                          v-model="beneficiary.adjustmentOfI485Status" class="w-full" label="">Adjustment of Status (I-485)
                        </vs-checkbox>

                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb10 " v-if="checkTemplateField('consularProcessing')">
                      <div class="main-placeholder right">
                        <!-- consularProcessing -->
                        <vs-checkbox name="consularProcessing"
                          
                          v-model="beneficiary.consularProcessing" class="w-full" label="">Consular Processing
                        </vs-checkbox>

                      </div>

                    </div>
                    <div class="vx-col md:w-1/2 w-full martb10 " v-if="checkTemplateField('areYouUnderRemoveOfIndOrUscis')">
                      <div class="main-placeholder right">
                        <!-- areYouUnderRemoveOfIndOrUscis -->
                        <vs-checkbox name="areYouUnderRemoveOfIndOrUscis"
                          
                          v-model="beneficiary.areYouUnderRemoveOfIndOrUscis" class="w-full" label="">Are you currently under removal proceedings by the INS/USCIS?
                        </vs-checkbox>

                      </div>

                    </div>


                    

                  </div>
                  </div>
          </vs-col>      

          <template v-if="checkTemplateField('gender')">
          <vs-col class="m-auto float-none demo-alignment beneficiary-info-btns pb-6" vs-type="flex"
            vs-justify="space-between" vs-align="center" vs-sm="12"   >
            <vs-button class="btn male-btn" :disabled="true"  @click="setGender('male')" v-bind:class="{
                isActivec: beneficiaryInfo.gender == 'male'
              }" icon-pack="IntakePortal" icon=" IP-femenine-1" type="border">Male</vs-button>
            <vs-button :disabled="true" v-bind:class="{
                isActivec: beneficiaryInfo.gender == 'female'
              }" class="btn female-btn" @click="setGender('female')" icon-pack="IntakePortal" icon=" IP-femenine-1"
              type="border">Female</vs-button>
            <vs-button :disabled="true"  v-bind:class="{ 
                isActivec: beneficiaryInfo.gender == 'others'
              }" class="btn others-btn" @click="setGender('others')" icon-pack="feather" icon="icon-circle"
              type="border">Others</vs-button>
            <vs-input style="display:none" name="gender" type="hidden" data-vv-as="Gender"  
              v-model="beneficiaryInfo.gender" />
            <div class="mt-0 mr-0" style="width:100%;">
              <span class="text-danger text-sm"
                v-show="errors.has('beneficiaryInfoform.gender')">{{ errors.first("beneficiaryInfoform.gender") }}</span>
            </div>
          </vs-col>

          <div class="divider"></div>
          </template>
          <template v-if="checkTemplateField('first_name') || checkTemplateField('middle_name')  || checkTemplateField('last_name') || 
          checkTemplateField('email') || checkTemplateField('dob') || checkTemplateField('marital_status')"  >
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vx-input-group class="form-input-group" >
                        <div class="form_group w-full" v-if="checkTemplateField('first_name')" >
                          <label class="form_label">First Name</label>
                          <vs-input name="firstname" v-model="beneficiaryInfo.firstName" 
                            class="w-full" data-vv-as="First Name"  />
                        </div>
                        <div class="form_group w-full" v-if="checkTemplateField('middle_name')">
                          <label class="form_label">Middle Name</label>
                          <vs-input class="w-full" name="middleName" v-model="beneficiaryInfo.middleName"
                            data-vv-as="Middle Name"   />
                        </div>
                        <div class="form_group w-full" v-if="checkTemplateField('last_name')" >
                          <label class="form_label">Last Name</label>
                          <vs-input class="w-full" name="lastName"  v-model="beneficiaryInfo.lastName"  
                            data-vv-as="Last Name" />
                        </div>
                      </vx-input-group>
                      <!-- <div class="input-group-error" v-if="checkTemplateField('last_name') || checkTemplateField('first_name')" >
                        <p class="w-1/3" v-if="checkTemplateField('first_name')">
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.firstname')">{{ errors.first("beneficiaryInfoform.firstname") }}</span>
                        </p>
                        <p class="w-1/3">

                        </p>
                        <p class="w-1/3" v-if="checkTemplateField('last_name') ">
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.lastName')">{{ errors.first("beneficiaryInfoform.lastName") }}</span>
                        </p>
                      </div> -->
                    </div>
                    <div class="vx-col w-full mb-5" v-if="checkTemplateField('ben_hasOtherNames')">
                      <div class="d-flex align-center">
                          <a class="mr-3">
                            Have you ever used any other names previously?
                          </a>

                          <vs-switch :disabled="true" v-model="beneficiaryInfo.ben_hasOtherNames" >
                              <span slot="on">Yes</span>
                              <span slot="off">No</span>
                          </vs-switch>
                      </div>

                  </div>


                  <template v-if="checkTemplateField('ben_hasOtherNames')">
                                        <div class="vx-col w-full" >
                                            <vx-input-group class="form-input-group">
                                                <div class="form_group w-full">
                                                    <label class="form_label">First Name<em>*</em></label>
                                                    <vs-input :name="'firstname_other'"  v-validate="'required'" class="w-full" data-vv-as="First Name" />
                                                </div>
                                                <div class="form_group w-full">
                                                    <label class="form_label">Middle Name</label>
                                                    <vs-input class="w-full" :name="'middleName_other'"  data-vv-as="Middle Name" />
                                                </div>
                                                <div class="form_group w-full">
                                                    <label class="form_label">Last Name</label>
                                                    <vs-input class="w-full" :name="'lastName_other'" data-vv-as="Last Name" />

                                                    <div class="delete" v-if="false">
                                                        <a >
                                                            <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </vx-input-group>
                                            <div class="input-group-error">
                                                <p class="w-1/3">
                                                    <span class="text-danger text-sm" v-show="
                          errors.has(
                            'beneficiaryInfoform.firstname_other' +
                              ind
                          )
                        ">{{
                          errors.first(
                            "beneficiaryInfoform.firstname_other" +
                              ind
                          )
                        }}</span>
                                                </p>
                                                <p class="w-1/3"></p>
                                                <p class="w-1/3">
                                                    <span class="text-danger text-sm" v-show="
                          errors.has(
                            'beneficiaryInfoform.lastName_other' +
                              ind
                          )
                        ">{{
                          errors.first(
                            "beneficiaryInfoform.lastName_other" +
                              ind
                          )
                        }}</span>
                                                </p>
                                            </div>

                                            <a class="add-more add-more-names" ><span>+</span>Add</a>
                                        </div>
                                    </template>

                    <div class="vx-col w-full"  v-if="checkTemplateField('email')" >
                      <div class="form_group ">
                        <label class="form_label">Email</label>
                        <vs-input name="email" v-model="beneficiaryInfo.email"    class="w-full"
                          data-vv-as="Email" />
                        <span class="text-danger text-sm"
                          v-show="errors.has('beneficiaryInfoform.email')">{{ errors.first("beneficiaryInfoform.email") }}</span>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('dateOfBirth')" >
                      <div class="form_group ">
                        <label class="form_label">Date of Birth</label>
                        <div class="main-placeholder right">
                          <datepicker  :typeable="true" name="dateOfBirth" 
                          :open-date="new Date(startEligibleDate)"
                          :disabled-dates="{from: new Date(startEligibleDate)}" data-vv-as="Date of Birth"
                            v-model="beneficiaryInfo.dateOfBirth"   placeholder="MM/DD/YYYY">
                          </datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.dateOfBirth')">{{ errors.first("beneficiaryInfoform.dateOfBirth") }}</span>
                        </div>
                      </div>

                      
                    </div>
                  <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('countryOfBirth')" >
                    <div class="form_group ">
                        <label class="form_label">Country of Birth</label>
                        <div class="main-placeholder right">
                          <multiselect name="countryOfBirth"   v-model="beneficiaryInfo.maritalStatus"   data-vv-as="Marital Status"
                                :show-labels="false" ref="bncountry" :disabled="true" track-by="id" label="name"  
                              placeholder="Select Country" :options="marital_statuses" :searchable="true" :allow-empty="false">
                          </multiselect>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.dateOfBirth')">{{ errors.first("beneficiaryInfoform.dateOfBirth") }}</span>
                        </div>
                      </div>


                  </div>



                       <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('provinceOfBirth')">
                                    <div class="form_group">
                                      <label class="form_label">Province of Birth<em>*</em> </label>
                                    <div class="main-placeholder right">
                                  

                                       <multiselect name="provinceOfBirth"     data-vv-as="Province of Birth"
                                :show-labels="false" ref="bncountry" :disabled="true" track-by="id" label="name"  
                              placeholder="Select Country" :options="marital_statuses" :searchable="true" :allow-empty="false">
                          </multiselect>

                                        <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.sevisNumber')">{{ errors.first('beneficiaryInfoform.sevisNumber')}}</span>
                                    </div>
                              </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('locationOfBirth')">
                                    <div class="form_group">
                                      <label class="form_label">Location of Birth<em>*</em> </label>
                                    <div class="main-placeholder right">
                                  
                                   
                                      <vs-input :disabled="true" class="w-full" data-vv-as="Location of Birth"  placeholder="Location of Birth"
                                      name="locationOfBirth"  />

                                        <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.sevisNumber')">{{ errors.first('beneficiaryInfoform.sevisNumber')}}</span>
                                    </div>
                              </div>
                              </div>
                              

                   <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('countryOfCitizenship')" >
                    <div class="form_group ">
                        <label class="form_label">Country of Citizenship</label>
                        <div class="main-placeholder right">
                          <multiselect name="countryOfCitizenship"     data-vv-as="Country of Citizenship"
                                :show-labels="false" ref="bncountry" :disabled="true" track-by="id" label="name"  
                              placeholder="Select Country" :options="marital_statuses" :searchable="true" :allow-empty="false">
                          </multiselect>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.dateOfBirth')">{{ errors.first("beneficiaryInfoform.dateOfBirth") }}</span>
                        </div>
                      </div>


                  </div> 

                   <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('I94')">
                                    <div class="form_group">
                                      <label class="form_label">I94<em>*</em> </label>

                                      <div class="vs-con-input">
                                      <vs-input :disabled="true" class="w-full" data-vv-as="I94  "  placeholder="I94 " 
                                :name="'I94'"  />  </div>
                              
                              </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('I94ExpiryDate') ">
                                    <div class="form_group">
                                      <label class="form_label">I-94 Expiry Date<em>*</em> </label>

                                      <div class="vs-con-input">
                                      <vs-input :disabled="true" class="w-full" data-vv-as="I94ExpiryDate  "  placeholder="I-94 Expiry Date " 
                                :name="'I94ExpiryDate'"  />  </div>
                              
                              </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('I94StatusName') ">
                                    <div class="form_group">
                                      <label class="form_label">I-94 Status Name<em>*</em> </label>

                                      <div class="vs-con-input">
                                      <vs-input :disabled="true" class="w-full" data-vv-as="I-94 Status Name  "  placeholder="I-94 Status Name " 
                                :name="'I94StatusName'"  />  </div>
                              
                              </div>
                              </div>

                     <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('marital_status')">
                                    <div class="form_group">
                                      <label class="form_label">Marital Status<em>*</em> </label>
                                    <div class="vs-con-input">
                                  

                                        <multiselect v-validate="'required'" name="maritalStatus"     data-vv-as="Marital Status"
                                :show-labels="false"  track-by="id" label="name"  :disabled="true"
                              placeholder="Select Status" :options="[]" :searchable="true" :allow-empty="false"  >
                          </multiselect>

                                        <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.sevisNumber')">{{ errors.first('beneficiaryInfoform.sevisNumber')}}</span>
                                    </div>
                              </div>
                      </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
          </template>
          <!--Phone Number Templaet--->
          <template v-if="checkTemplateField('cell_phone_number') || checkTemplateField('home_phone_number')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('cell_phone_number')" >
                <div class="form_group ph_number">
                        <label class="form_label">Phone Number</label>
<!-- v-validate="'required|phonevalid'" -->
                        <vs-input
                        v-mask="'(###)-###-####'"
                        v-model="beneficiaryInfo.cellPhoneNumber"
                        name="cellPhoneNumber"
                      v-validate="'required|phonevalid'"
                        data-vv-as="Phone Number"
                        placeholder="(XXX)-XXX-XXXX"
                        wrapperClass="vs-con-input"
                        class="w-full"
                        inputClass="vs-inputx vs-input--input normal" 
                      />
                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.cellPhoneNumber')">{{ errors.first("beneficiaryInfoform.cellPhoneNumber") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('home_phone_number')"  >
<!-- v-validate="'required|phonevalid'" -->
                  <div class="form_group ph_number">
                      <label class="form_label">Home Phone Number</label>
                  <vs-input
                        v-mask="'(###)-###-####'"
                        v-model="beneficiaryInfo.homePhoneNumber"
                        name="homePhoneNumber"
                        v-validate="'required|phonevalid'"
                        data-vv-as="Home Phone Number"
                        placeholder="(XXX)-XXX-XXXX"
                        wrapperClass="vs-con-input"
                        class="w-full"
                        inputClass="vs-inputx vs-input--input normal" 
                      />
                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.homePhoneNumber')">{{ errors.first("beneficiaryInfoform.homePhoneNumber") }}</span>
                </div>
                </div>
                <!-- <div class="vx-col md:w-1/2 w-full">


                  <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label for="" class="vs-input--label">Work Phone Number</label>
                    <phone-mask-input v-model="beneficiaryInfo.workPhoneNumber" autoDetectCountry
                      name="workPhoneNumber" v-validate="'phoneNumber'" data-vv-as="Work Phone Number"
                      placeholder="+X(XXX)-XXX-XXXX" wrapperClass="vs-con-input"
                      inputClass="vs-inputx vs-input--input normal" label="Home Phone Numbe" />

                  </div>




                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.workPhoneNumber')">{{ errors.first("beneficiaryInfoform.workPhoneNumber") }}</span>
                </div> -->
                <!-- <div class="vx-col md:w-1/2 w-full">



                  <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label for="" class="vs-input--label">Fax Number</label>
                    <phone-mask-input v-model="beneficiaryInfo.faxNumber" autoDetectCountry name="faxNumber"
                      v-validate="'phoneNumber'" data-vv-as="Fax Number" placeholder="+X(XXX)-XXX-XXXX"
                      wrapperClass="vs-con-input" inputClass="vs-inputx vs-input--input normal" label="Fax Numbe" />

                  </div>




                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.faxNumber')">{{ errors.first("beneficiaryInfoform.faxNumber") }}</span>
                </div> -->
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
          </template>

        <!--Education Templaet--->
        <template v-if="checkTemplateField('highest_degree') || checkTemplateField('major_field_of_study')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">Education</h3>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('highest_degree') ">
                <div class="form_group">
                      <label class="form_label">Highest Degree</label>
                  <!-- <vs-select   name="highestDegree"
                    v-model="beneficiaryInfo.education.highestDegree" class="w-full select-large"
                    data-vv-as="Highest Degree" label="Highest Degree">
                    <vs-select-item :key="index" :value="item.id" :text="item.name"
                      v-for="(item,index) in education_types" class="w-full" />
                  </vs-select>  -->
                    <div class="con-select">
                    <multiselect :disabled="true" name="highestDegree"   v-model="beneficiaryInfo.education.highestDegree"   data-vv-as="Highest Degree"
                        :show-labels="true"  track-by="id" label="name"  
                      placeholder="Select HighestDegree" :options="education_types" :searchable="true" :allow-empty="false">
                    </multiselect>
                    </div>
                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.highestDegree')">{{ errors.first("beneficiaryInfoform.highestDegree") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if=" checkTemplateField('major_field_of_study')">
                <div class="form_group">
                    <label class="form_label">Major Field of Study</label>
                    <vs-input   class="w-full" name="majorFieldOfStudy"
                      v-model="beneficiaryInfo.education.majorFieldOfStudy" data-vv-as="Major Field of Study" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.majorFieldOfStudy')">{{ errors.first("beneficiaryInfoform.majorFieldOfStudy") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>


        <template  v-if="
          checkTemplateField('passportNumber') 
          || checkTemplateField('passportIssuedDate')
          || checkTemplateField('passportIssuedCountry')
          || checkTemplateField('passportExpiryDate')
          || checkTemplateField('curVisaExpiryDate')
          || checkTemplateField('curNonImmigrantVisaStatus') 
          || checkTemplateField('sevisNumber')
          || checkTemplateField('eadNumber')
          || checkTemplateField('ben_currentlyInUS')
         
        " >
                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center"  vs-sm="12">
                      <div class="form-container w-full">
                      <h3 class="small-header">Passport </h3>
                        <div class="vx-row">
                        

                          <div class="vx-col w-full">

                            <div class="vx-row delete-row" >


                            <div class="vx-col lg:w-1/2 w-full" v-if="checkTemplateField('passportNumber') ">
                              <div class="form_group">
                                <label class="form_label">Passport No</label>
                                <vs-input :disabled="true"  oninput="this.value = this.value.replace(/[^a-z A-Z 0-9]/g, '');"  data-vv-as="Passport Number"  name="benpassportNumber"  v-validate="'max:15'"  class="w-full"
                                    />
                                  <span class="text-danger text-sm"
                                    v-show="errors.has('beneficiaryInfoform.benpassportNumber')">{{ errors.first("beneficiaryInfoform.benpassportNumber") }}</span>
                              </div>
                            </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('passportIssuedDate')">
                                
                                <div class="form_group">
                                  <label class="form_label">Passport Issued Date </label>
                                  <datepicker  :typeable="true" data-vv-as="Passport Issued Date " :name="'passportIssuedDate'"  :disabled="true"
                                  
                                    placeholder="DD/MM/YYYY"></datepicker>
                                    <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.passportIssuedDate')">{{ errors.first('beneficiaryInfoform.passportIssuedDate')}}</span>
                                </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('passportExpiryDate')">
                                
                                <div class="form_group" >
                                <label class="form_label">Date of Passport Expiry </label>
                                  

                                     <datepicker  :typeable="true" :name="'benpassportExpiryDate'"  :disabled="true"   placeholder="DD/MM/YYYY" ></datepicker>
                                    <span class="text-danger text-sm"
                                      v-show="errors.has('beneficiaryInfoform.benpassportExpiryDate')">{{ errors.first('beneficiaryInfoform.benpassportExpiryDate') }}</span>
                                      
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('curVisaExpiryDate')">
                                
                                <div class="form_group" >
                                <label class="form_label">Current Status Expiry Date<em>*</em></label>
                                  <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                                    <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.curVisaExpiryDate')">{{ errors.first('beneficiaryInfoform.curVisaExpiryDate') }}</span>
                                      
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('passportIssuedCountry')">
                                
                                <div class="form_group" >
                                <label class="form_label">Passport Issued Country<em>*</em></label>
                                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                                @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                                placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                              </multiselect>
                                </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('curNonImmigrantVisaStatus')">
                                    <div class="form_group">
                                      <label class="form_label">Current Nonimmigrant status<em>*</em>  </label>
                                    <vs-input  :disabled="true" class="w-full" data-vv-as="Current Nonimmigrant status  "  placeholder="Current Nonimmigrant status  " 
                                :name="'curNonImmigrantVisaStatus'"  /> 
                                <span class="text-danger text-sm" 
                                  v-show="errors.has('beneficiaryInfoform.curNonImmigrantVisaStatus')">{{ errors.first('beneficiaryInfoform.curNonImmigrantVisaStatus')}}</span>
                              </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('sevisNumber')">
                                    <div class="form_group">
                                      <label class="form_label">SEVIS  Number<em>*</em> </label>
                                    <div class="vs-con-input">
                                  

                                       <vs-input :disabled="true" class="w-full" data-vv-as="SEVIS  Number  "  placeholder="SEVIS  Number " 
                                :name="'sevisNumber'"  /> 

                                        <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.sevisNumber')">{{ errors.first('beneficiaryInfoform.sevisNumber')}}</span>
                                    </div>
                              </div>
                              </div>

                              <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('eadNumber')">
                                    <div class="form_group">
                                      <label class="form_label">EAD Number<em>*</em> </label>

                                      <div class="vs-con-input">
                                        <the-mask  autocomplete="off" autocorrect="off"   :name="'eadNumber'"    class="vs-inputx vs-input--input full"
                                        data-vv-as="EAD  Number "  v-validate="'required|min:9|max:9'"  placeholder="### - ### - ####"   :mask="['### - ### - ###']"/>
                                      
                                        <span class="text-danger text-sm"  v-show="errors.has('beneficiaryInfoform.eadNumber')">{{ errors.first('beneficiaryInfoform.eadNumber')}}</span>
                                    </div>
                              
                              </div>
                              </div>
                              
                              
                            </div>
                          </div>
        
                        </div>
                      </div>

                    </vs-col>
                    <div class="divider mt-8"></div>
        </template> 


        <template 
        
        v-if="
        checkTemplateField('ben_haveOwnershipInterest') 
        || checkTemplateField('ben_ownershipInterestDesc') 
        || checkTemplateField('ben_consulateInfo') 
        || checkTemplateField('ben_alienNumber') 
        || checkTemplateField('ben_lastArrivalDate') 
        || checkTemplateField('ben_placeOfLastEntryInUS') 
        || checkTemplateField('ben_educations') 
        || checkTemplateField('ben_nonImmPetitionsInfo') 
        || checkTemplateField('ben_anyImmPetitionFiled') 
        || checkTemplateField('ben_immPetitionInfo') 
        || checkTemplateField('ben_prevEmploymentInfo') 
        || checkTemplateField('ben_addressOutsideUS') 
       
        
        "
         >
        <!-----New Fields-->

        <template  v-if="
        checkTemplateField('ben_haveOwnershipInterest') 
        || checkTemplateField('ben_ownershipInterestDesc')  ">
          <vs-col class="m-auto float-none" vs-sm="12">
            <div class="alert-content-block">
              <p class="pt-2"> Do you have ownership interest in this Company?</p>
              <div class="form_radio_btns">
                <vs-button  :disabled="true"  v-bind:class="{
                  cactive: beneficiaryInfo.haveOwnershipInterest
                }" @click="beneficiaryInfo.haveOwnershipInterest = true" class="yes mr-5" color="success" type="border">
                  Yes</vs-button>
                <vs-button :disabled="true" class="no" v-bind:class="{
                  cactive: !beneficiaryInfo.haveOwnershipInterest
                }" @click="beneficiaryInfo.haveOwnershipInterest = false" color="danger" type="border">No</vs-button>
              </div>
              <div class="form-container mt-6" v-if=" checkTemplateField('ben_ownershipInterestDesc')"  >
                <div class="vx-row">

            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">Ownership interest description</label>

                <!-- <vs-textarea :disabled="true" ></vs-textarea> -->
                <ckeditor :disabled="true"  :editor="editor" :config="editorConfig"></ckeditor>

                
                
                
              </div>
                
                
              </div>

                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>
         <template  v-if="
        checkTemplateField('ben_consulateInfo') 
          ">
          <vs-col class="m-auto float-none" vs-sm="12">
            <div class="alert-content-block">
              <p class="pt-2"> Consulate you want to attend the visa interview?</p>
              <div class="form_radio_btns">
                <vs-button  :disabled="true"  v-bind:class="{
                  cactive: beneficiaryInfo.ben_consulateInfo
                }" @click="beneficiaryInfo.ben_consulateInfo = true" class="yes mr-5" color="success" type="border">
                  Yes</vs-button>
                <vs-button :disabled="true" class="no" v-bind:class="{
                  cactive: !beneficiaryInfo.ben_consulateInfo
                }" @click="beneficiaryInfo.ben_consulateInfo = false" color="danger" type="border">No</vs-button>
              </div>
              <div class="form-container mt-6" >
                <div class="vx-row">

                  <div class="vx-col md:w-1/2 w-full" >
                      <div class="form_group">
                        <label for class="form_label">Country</label>
                        <div class="con-select w-full">
                          
                          <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                            @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                            placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm"
                          v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                      </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label for class="form_label">State</label>
                    <div class="con-select w-full ">
                      
                      <multiselect name="state"   v-model="stateModel"
                        :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                        track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                        :allow-empty="false"></multiselect>
                    </div>

                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                  </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full" >
                    <div class="form_group">
                      <label for class="form_label">City</label>
                      <div class="con-select w-full">                      
                        <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                          :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                          label="name" placeholder="Select City" :options="locations" :searchable="true"
                          :allow-empty="false"></multiselect>
                      </div>

                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>

         <template  v-if="checkTemplateField('ben_alienNumber') ||  checkTemplateField('ben_placeOfLastEntryInUS')  ||  checkTemplateField('ben_lastArrivalDate') 
          ">
          <vs-col class="m-auto float-none" vs-sm="12">
            
              
              
              <div class="form-container " >
                <div class="vx-row martb10">

                

                  <div class="vx-col md:w-1/3 w-full"  v-if="checkTemplateField('ben_lastArrivalDate') ">
                    <div class="form_group" >
                    <label class="form_label">Date of Last Entry into USA <em>*</em></label>
                      <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                        <span class="text-danger text-sm" v-show="errors.has('beneficiaryInfoform.curVisaExpiryDate')">{{ errors.first('beneficiaryInfoform.curVisaExpiryDate') }}</span>
                          
                    </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full" v-if="checkTemplateField('ben_alienNumber') " >
                    <div class="form_group">
                      <label for class="form_label">Alien Number</label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Alien Number"></vs-input>
                      </div>

                    
                    </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full" v-if="checkTemplateField('ben_placeOfLastEntryInUS') " >
                    <div class="form_group">
                      <label for class="form_label">Place of Last Entry into USA</label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Place of Last Entry into USA"></vs-input>
                      </div>

                    
                    </div>
                  </div>
                  

                  </div>
              </div>
            
          </vs-col>
          <div class="divider"></div>
        </template>

         <!--Educations Templaet--->
        <template v-if="checkTemplateField('ben_educations')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">Educations</h3>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full"  >
                  <div class="form_group">
                        <label class="form_label">Highest Degree</label>
                    
                      <div class="con-select">
                      <multiselect :disabled="true" name="highestDegree"   v-model="beneficiaryInfo.education.highestDegree"   data-vv-as="Highest Degree"
                          :show-labels="true"  track-by="id" label="name"  
                        placeholder="Select HighestDegree" :options="education_types" :searchable="true" :allow-empty="false">
                      </multiselect>
                      </div>
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.highestDegree')">{{ errors.first("beneficiaryInfoform.highestDegree") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Major Field of Study</label>
                    <vs-input   class="w-full" name="majorFieldOfStudy"
                      v-model="beneficiaryInfo.education.majorFieldOfStudy" data-vv-as="Major Field of Study" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.majorFieldOfStudy')">{{ errors.first("beneficiaryInfoform.majorFieldOfStudy") }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full"  >
                  <div class="form_group">
                        <label class="form_label">Attended from<em>*</em></label>
                    
                      <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Attended To<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Year of Graduation<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>

                <div class="vx-col md:w-1/2 w-full"   > 
                      <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_educations" class="w-full"
                          label="Highest Degree" >Was the University Accredited at the time of your graduation?</vs-checkbox> 
                      </div> 
                </div>
                <div class="vx-col md:w-1/2 w-full"  v-if=" checkTemplateField('ben_nonImmPetitionsInfo') " > 
                      <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_nonImmPetitionsInfo" class="w-full"
                          label="Highest Degree" >Is the University a for-profit Organization?</vs-checkbox> 
                      </div> 
                </div>
              </div>

            
              <h3 class="small-header">Address</h3>
              <div class="vx-row">
                
                <div  class="vx-col w-full">
                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                    <li v-if="checkTemplateField('ben_currentlyInUS')">
                      <vs-radio @click="setDefaultcountry" v-model="beneficiaryInfo.ben_currentlyInUS" vs-value='true'>Are you currently in USA?
                      </vs-radio>
                    </li>
                  </ul>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')" >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')"  >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_country')">
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_state')">
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_city')">
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_zipcode')">
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
              <template v-if=" checkTemplateField('mailingAddress') "  >
              <h3 class="small-header">Malling Address</h3>
              <div class="vx-row">
                
                
                <div class="vx-col md:w-1/2 w-full"  >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"   >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
              </template>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>

        <template v-if="checkTemplateField('ben_nonImmPetitionsInfo')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">Non-Immigrant Petitions Information</h3>
              
              <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full"  >
                    <div class="form_group">
                      <label for class="form_label">Visa Status</label>
                      <div class="con-select w-full ">
                        
                        

                        <multiselect name="VisaStatus"   v-model="bncountryModel" :disabled="true "
                        @select="selectCountry" :show-labels="false" ref="VisaStatus" track-by="id" label="Visa Status" data-vv-as="Visa Status"
                        placeholder="Visa Status" :options="visastatuses" :searchable="true" :allow-empty="false">
                      </multiselect>
                      </div>

                    
                    </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full"  >
                    <div class="form_group">
                      <label for class="form_label">Receipt Number</label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Receipt Number"></vs-input>
                      </div>

                    
                    </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full"  >
                    <div class="form_group">
                      <label for class="form_label">Petitioner Name</label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Petitioner Name"></vs-input>
                      </div>

                    
                    </div>
                  </div>
              </div>

            
              
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>

        <template v-if="checkTemplateField('ben_anyImmPetitionFiled')">

          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">Immigrant Petition Information</h3>
              
              <div class="vx-row">
                <div class="vx-col md:w-full  w-full"   > 
                      <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_educations" class="w-full"
                          label="Highest Degree" >Has any other Alien Employment Certification, a.k.a Labor Certification been filed on your behalf?</vs-checkbox> 
                      </div> 
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Filed Date<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                
                    <div class="form_group">
                      <label for class="form_label">Name of the Employer <em>*</em></label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Name of the Employer"></vs-input>
                      </div>

                    
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full"  >

                     <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_educations" class="w-full"
                          label="Highest Degree" >RIR or Regular Processing?</vs-checkbox> 
                      </div> 
                    
                  </div>
                  <div class="vx-col md:w-1/2 w-full"  >
                    <div class="form_group">
                      <label for class="form_label">Filed State</label>
                      <div class="con-select w-full ">
                        
                        <multiselect name="filedStateId"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Filed State" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                      </div>

                    
                    </div>
                  </div>
                  <div class="vx-col md:w-1/3 w-full"  >
                    <div class="form_group">
                      <label for class="form_label">Current Status of the Application</label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Current Status of the Application"></vs-input>
                      </div>

                    
                    </div>
                  </div>

                  <div class="vx-col md:w-full  w-full"   > 
                      <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_educations" class="w-full"
                          label="Highest Degree" >Are you seeking to utilize the filing date from a previously submitted Application for Alien Employment Certification (ETA 750)?   </vs-checkbox> 
                      </div> 
                 </div>
                 <div class="vx-col md:w-full  w-full"   > 
                      <div class="main-placeholder right">
                        <vs-checkbox   name="Highest Degree"  v-model="beneficiary.ben_educations" class="w-full"
                          label="Highest Degree" >Has any I-140 Petition been filed on your behalf?    </vs-checkbox> 
                      </div> 
                 </div>
                  
                 
              </div>
               <div class="vx-row">
                 <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Filed Date<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                
                    <div class="form_group">
                      <label for class="form_label">Name of the Employer <em>*</em></label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Name of the Employer"></vs-input>
                      </div>

                    
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Priority Date<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                
                    <div class="form_group">
                      <label for class="form_label">EB2/EB3 <em>*</em></label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="EB2/EB3"></vs-input>
                      </div>

                    
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                
                    <div class="form_group">
                      <label for class="form_label">Current Status <em>*</em></label>
                      <div class="con-select w-full ">
                        
                        <vs-input class="w-full" :disabled="true" placeholder="Current Status"></vs-input>
                      </div>

                    
                    </div>
                </div>
               
               </div>

            
              
            </div>
          </vs-col>
            <div class="divider"></div>
        </template>

        <template v-if="checkTemplateField('ben_prevEmploymentInfo')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
             <h3 class="small-header">Previous Employment Information</h3>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full"  >

                  
                      <div class="form_group">
                        <label for class="form_label">Name of the Employer <em>*</em></label>
                        <div class="con-select w-full ">
                          
                          <vs-input class="w-full" :disabled="true" placeholder="Name of the Employer"></vs-input>
                        </div>

                      
                      </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                  
                      <div class="form_group">
                        <label for class="form_label">Business Type <em>*</em></label>
                        <div class="con-select w-full ">
                          
                          <vs-input class="w-full" :disabled="true" placeholder="Business Type"></vs-input>
                        </div>

                      
                      </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"  >

                  
                      <div class="form_group">
                        <label for class="form_label">Job Title <em>*</em></label>
                        <div class="con-select w-full ">
                          
                          <vs-input class="w-full" :disabled="true" placeholder="Job Title"></vs-input>
                        </div>

                      
                      </div>
                </div>
                 <div class="vx-col md:w-1/2 w-full"  >

                  
                      <div class="form_group">
                        <label for class="form_label">Job Duties <em>*</em></label>
                        <div class="con-select w-full ">
                          
                          <vs-input class="w-full" :disabled="true" placeholder="Job Duties"></vs-input>
                        </div>

                      
                      </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">Start Date<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                  <div class="form_group">
                    <label class="form_label">End Date<em>*</em></label>
                    <datepicker  :typeable="true" :name="'curVisaExpiryDate'" :disabled="true" placeholder="DD/MM/YYYY"></datepicker>
                    
                  </div>
                </div>

              
              </div>
              
              
              <h3 class="small-header">Address</h3>
              <div class="vx-row">
                
                <div  class="vx-col w-full mb-5">
                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                  
                    <li v-if="checkTemplateField('ben_currentlyInUS')">
                      <vs-radio @click="setDefaultcountry" v-model="beneficiaryInfo.ben_currentlyInUS" vs-value='true'>Are you currently in USA?
                      </vs-radio>
                    </li>
                    </ul>
                
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')" >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')"  >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_country')">
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_state')">
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_city')">
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_zipcode')">
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>

        <template v-if="checkTemplateField('ben_addressOutsideUS')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container w-full">
              <h3 class="small-header">Address Outside the U.S</h3>
              
            
              <div class="vx-row">
                
                <div  class="vx-col w-full mb-5">
                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                  
                    <li v-if="checkTemplateField('ben_currentlyInUS')">
                      <vs-radio @click="setDefaultcountry" v-model="beneficiaryInfo.ben_currentlyInUS" vs-value='true'>Are you currently in USA?
                      </vs-radio>
                    </li>
                    </ul>
                
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')" >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')"  >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_country')">
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_state')">
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_city')">
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_zipcode')">
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>



        
        
        </template> 
      <!--Address Templaet--->
        <template v-if="checkTemplateField('iam_from_us') ||  checkTemplateField('iam_notfrom_us') || checkTemplateField('beneficiary_address_line1') || checkTemplateField('beneficiary_address_line2')
        || checkTemplateField('beneficiary_address_country') || checkTemplateField('beneficiary_address_state')
        || checkTemplateField('beneficiary_address_city') || checkTemplateField('beneficiary_address_zipcode')
        " >
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container">
              <h3 class="small-header">Address </h3>
              <div class="vx-row">
                <div class="vx-col w-full mb-5" v-if="false && checkTemplateField('iam_from_us') && checkTemplateField('iam_notfrom_us')" >
                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                    <li v-if="checkTemplateField('iam_from_us')">
                      <vs-radio @click="setDefaultcountry" v-model="beneficiaryInfo.iAmFromUS" vs-value='true'>I am in the United States
                      </vs-radio>
                    </li>
                    <li  v-if="checkTemplateField('iam_notfrom_us')" >
                  
                      <vs-radio v-model="beneficiaryInfo.iAmFromUS" vs-value='false'>I am not in the United States
                      </vs-radio>
                    </li>
                  </ul>
                </div>
                <div  class="vx-col w-full mb-5" v-if="false && checkTemplateField('ben_currentlyInUS')" >
                  <ul class="demo-alignment custom-radio" vs-type="flex" vs-align="center">
                  
                    <li v-if="checkTemplateField('ben_currentlyInUS')">
                      <vs-radio @click="setDefaultcountry" v-model="beneficiaryInfo.ben_currentlyInUS" vs-value='true'>Are you currently in USA?
                      </vs-radio>
                    </li>
                    </ul>
                
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')" >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_line1')"  >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_country')">
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_state')">
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_city')">
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('beneficiary_address_zipcode')">
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
              <template >
              <h3 class="small-header">Malling Address</h3>
              <div class="vx-row">
                
                
                <div class="vx-col md:w-1/2 w-full"  >
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                    <vs-input name="address2" v-model="beneficiaryInfo.address.line2" class="w-full"
                      data-vv-as="Street Address"   @blur="setDependentsInfoAddress(true)" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.address2')">{{ errors.first("beneficiaryInfoform.address2") }}</span>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full"   >
                  <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="beneficiaryInfo.address.line1" @blur="setDependentsInfoAddress(false)"
                        class="w-full" data-vv-as="Apt, Suite"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('beneficiaryInfoform.address1')">{{ errors.first("beneficiaryInfoform.address1") }}</span>
                    </div>
                </div>
                
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">Country</label>
                  <div class="con-select w-full">
                    
                    <multiselect name="country"   v-model="bncountryModel" :disabled="checkCountry === false  "
                      @select="selectCountry" :show-labels="false" ref="bncountry" track-by="id" label="name" data-vv-as="Country"
                      placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                    </multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.country')">{{ errors.first("beneficiaryInfoform.country") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">State</label>
                  <div class="con-select w-full ">
                    
                    <multiselect name="state"   v-model="stateModel"
                      :disabled="states.length == 0" @select="selectState" :show-labels="false" label="name"
                      track-by="id" data-vv-as="State" placeholder="Select State" :options="states" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.state')">{{ errors.first("beneficiaryInfoform.state") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">City</label>
                  <div class="con-select w-full">                      
                    <multiselect name="city"   v-model="locationModel" @select="selectLocation"
                      :show-labels="false" :disabled="locations.length == 0" track-by="id" data-vv-as="City"
                      label="name" placeholder="Select City" :options="locations" :searchable="true"
                      :allow-empty="false"></multiselect>
                  </div>

                  <span class="text-danger text-sm"
                    v-show="errors.has('beneficiaryInfoform.city')">{{ errors.first("beneficiaryInfoform.city") }}</span>
                </div>
                </div>
                <div class="vx-col md:w-1/2 w-full" >
                <div class="form_group">
                  <label for class="form_label">Zip Code</label>
                  <vs-input name="zipcode" v-model="beneficiaryInfo.address.zipcode" @blur="setSpouseZipcode()"
                    v-validate="'numeric|required|zipcodev:bncountry'" class="w-full" data-vv-as="Zip Code"  />
                    <span class="text-danger text-sm"
                      v-show="errors.has('beneficiaryInfoform.zipcode')">{{ errors.first("beneficiaryInfoform.zipcode") }}</span>
                  </div>
                </div>
              </div>
            </template>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>



        <template v-if="checkTemplateField('SSN')">
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="main-placeholder right info-right">
                    

                    <div class="vs-component vs-con-input-label vs-input w-full ssnnumber vs-input-primary">
                      <div class="form_group">
                        <label class="form_label"> Social Security number (if applicable)</label>
                        <div class="vs-con-input">
                          <the-mask v-validate="'min:9|max:9'" name="ssn" data-vv-as="Social Security number (if applicable)" v-model="beneficiaryInfo.SSN"
                            placeholder="123 - 45 - 6789" class="vs-inputx vs-input--input normal"
                            :mask="['### - ## - ####']" />
                        </div>
                        <span class="text-danger text-sm"
                          v-show="errors.has('beneficiaryInfoform.ssn')">{{ errors.first(('beneficiaryInfoform.ssn')) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider" v-if="beneficiaryInfo.iAmFromUS == 'false'" ></div>
        </template>
        <template v-if="checkTemplateField('consulateNotifyAddress')">
          <vs-col v-if="beneficiaryInfo.iAmFromUS == 'false' && checkTemplateField('consulateNotifyAddress') " class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container">
              <div class="vx-row">
                <div class="vx-col w-full" >
                  <label class="custom-label">
                    Consulate to Notify upon Approval of your petition (if outside the
                    USA)
                  </label>
                  <!-- <vs-textarea v-model="beneficiaryInfo.consulateNotifyAddress"  class="w-full" data-vv-as="Consulate to Notify upon Approval of your petition (if outside the
                    USA)" /> -->
                    <ckeditor v-model="beneficiaryInfo.consulateNotifyAddress"  class="w-full" data-vv-as="Consulate to Notify upon Approval of your petition (if outside the
                    USA)"  :editor="editor" :config="editorConfig"></ckeditor>

                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>
        <template v-if="checkTemplateField('hasI140ImmPetitionFiled') ">
          <vs-col class="m-auto float-none" vs-sm="12">
            <div class="alert-content-block">
              <p class="pt-2"> Has an I-140 immigrant petition been filed on your behalf? Details</p>
              <div class="form_radio_btns">
                <vs-button  :disabled="true"  v-bind:class="{
                  cactive: beneficiaryInfo.hasI140ImmPetitionFiled
                }" @click="beneficiaryInfo.hasI140ImmPetitionFiled = true" class="yes mr-5" color="success" type="border">
                  Yes</vs-button>
                <vs-button :disabled="true" class="no" v-bind:class="{
                  cactive: !beneficiaryInfo.hasI140ImmPetitionFiled
                }" @click="beneficiaryInfo.hasI140ImmPetitionFiled = false" color="danger" type="border">No</vs-button>
              </div>
              <div class="form-container mt-6" v-if="beneficiaryInfo.hasI140ImmPetitionFiled && checkTemplateField('docs_i140_approval_notice')"  >
                <div class="vx-row">

            <div class="vx-col w-full">
              <div class="form_group">
                <label class="form_label">I-140 Approval Notice, if any</label>
                <file-upload :disabled="true" v-model="documents.I140ApprovalNotice" class="file-upload-input mb-1" 
                name="I140ApprovalNoticeDocument" data-vv-as="INS Notices" :multiple="true"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @input="upload(documents.I140ApprovalNotice)">
                  <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
                </file-upload>
                
                <span class="text-danger text-sm"
                v-show="errors.has('I140ApprovalNoticeDocument')">{{ errors.first("I140ApprovalNoticeDocument") }}</span>
              </div>
                <ul  class="uploaded-list">
                  <template v-for="(item, index) in documents.I140ApprovalNotice">
                  <vs-chip @click="remove(item, documents.I140ApprovalNotice)"  v-if="item.status !== false" :key="index" closable> {{ item.name }} </vs-chip>
                  </template>
                </ul>
                
              </div>

                </div>
              </div>
            </div>
          </vs-col>
          <div class="divider"></div>
        </template>

        <template  v-if="checkTemplateField('priorPeriodOfStayInUS')" >
        
          <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
            <div class="form-container">
              <div class="vx-row">
                <div class="vx-col w-full mt-6">
                  <p>All prior periods of stay in the U.S. over the last seven years</p>
                </div>

                <div class="vx-col w-full">

                  <div class="vx-row delete-row" v-for="(priorstay, index) in priorPeriodOfStayInUS" :key="priorstay.id">
                    <div class="vx-col md:w-1/3 w-full">
                      <div class="form_group">
                      <label class="form_label">Date Entered</label>
                      <div class="main-placeholder right">
                        <datepicker  :typeable="true" data-vv-as="Date Entered" :name="'enterDate'+index" 
                        :disabled-dates="{to: new Date(startBeneficiaryDateEntered), from: new Date()}" v-model="priorstay.enteredDate"
                          placeholder="MM/DD/YYYY"></datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.enterDate'+index)">{{ errors.first('beneficiaryInfoform.enterDate'+index)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                      <div class="form_group">
                      <label class="form_label">Date Departed</label>
                      <div class="main-placeholder right">

                        <datepicker  :typeable="true"  :name="'departDate'+index" v-validate="{required: priorstay.enteredDate != null && !priorstay.departedDate }" data-vv-as="Date Departed"
                        :disabled="priorstay.enteredDate === null" :disabled-dates="{to: priorstay.enteredDate, from: new Date()}" v-model="priorstay.departedDate"
                          placeholder="MM/DD/YYYY"></datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.departDate'+index)">{{ errors.first('beneficiaryInfoform.departDate'+index) }}</span>
                            </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                          <div class="form_group">
                            <label class="form_label">Case Status</label>
                            <multiselect name="VisaStatus"   v-model="bncountryModel" :disabled="true"
                            @select="selectCountry" :show-labels="false" ref="VisaStatus" track-by="id" label="Visa Status" data-vv-as="Visa Status"
                            placeholder="Visa Status" :options="visastatuses" :searchable="true" :allow-empty="false">
                          </multiselect>


                    
                      <span class="text-danger text-sm" 
                        v-show="errors.has('beneficiaryInfoform.selectVisaStatus'+index)">{{ errors.first('beneficiaryInfoform.selectVisaStatus'+index)}}</span>
                    </div>
                    </div>
                    <div class="delete" v-if="priorPeriodOfStayInUS.length > 1">
                      <a @click="removepriorstay(index)">
                        <img src="@/assets/images/main/delete-row-img.svg">
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </vs-col>
          <vs-col class="m-auto float-none" vs-type="flex" vs-align="center" vs-sm="12">
            <a :disabled="true"   class="add-more ml-0" type="filled">
              <span>+</span> More
            </a>
          </vs-col>
        </template>  

        </form>
      </div>
    </div> 
  </div>
  <div>
    <div class="block_title pb-0 pt-8">
      Documents
    </div> 
    <div class="block-layout">
      <div class=" wizard-container questionnaireeditor questionnairesection form_section pad0"> 
      <vs-col class="m-auto float-none pt-0" vs-type="flex" vs-justify="center" vs-align="center"
        vs-sm="12">
        <div class="form-container w-full">
          <h3 class="small-header">
            List of documents needs to be updated
            <span class="file-type">
              (File Type: PDF,
              DOC, JPEG, PNG. Max
              file size: 1MB)
            </span>
          </h3>
          <div class="vx-row">
          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_passport')" >
              <div class="form_group">
              <label class="form_label">{{('passportVisaI94') |formatdoctype}} </label>
              <file-upload :disabled="true" :diasbled="true" class="file-upload-input"
                name="passportVisaI94Document" data-vv-as="Passport, along with Case and Form I-94 (clearly showing the dates of
                first and last entry into the United States)" 
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :multiple="true" @input="upload(documents.passportVisaI94)">
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('passportVisaI94Document')">{{ errors.first("passportVisaI94Document") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.passportVisaI94">
                <vs-chip @click="remove(item, documents.passportVisaI94)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="Passport, along with Visa and Form I-94 (clearly showing the dates of
                first and last entry into the United States)" /> -->
            </div>
             <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_passport_visa_i94')" >
              <div class="form_group">
              <label class="form_label">{{('passportVisaI94') |formatdoctype}}</label>
              <file-upload :disabled="true" v-model="documents.passportVisaI94" class="file-upload-input"
                name="passportVisaI94Document" data-vv-as="Passport, along with Case and Form I-94 (clearly showing the dates of
                first and last entry into the United States)" 
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :multiple="true" @input="upload(documents.passportVisaI94)">
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('passportVisaI94Document')">{{ errors.first("passportVisaI94Document") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.passportVisaI94">
                <vs-chip @click="remove(item, documents.passportVisaI94)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="Passport, along with Visa and Form I-94 (clearly showing the dates of
                first and last entry into the United States)" /> -->
            </div>
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_resume')">
              <div class="form_group">
                <label class="form_label">Resume</label>
                <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  name="resumeDocument" data-vv-as="Resume" :multiple="true"
                  @input="upload(documents.resume)" >
                  <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                  Upload
                </file-upload>                    
                <span class="text-danger text-sm"
                v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.resume">
                <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
              
            </div>
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_education')" >
              <div class="form_group">
              <label class="form_label">{{'education' | formatdoctype}}</label>
              <file-upload :disabled="true" v-model="documents.education" class="file-upload-input" 
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                name="educationDocument" data-vv-as="Education (10th / 12th Grade/Undergraduate/graduate degree(s) along with
                transcripts and any other certificates)" :multiple="true" @input="upload(documents.education)">
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('educationDocument')">{{ errors.first("educationDocument") }}</span>
              </div>
              <ul  class="uploaded-list">
              <template v-for="(item, index) in documents.education">
                <vs-chip @click="remove(item, documents.education)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="Education (10th / 12th Grade/Undergraduate/graduate degree(s) along with
                transcripts and any other certificates)" /> -->
            </div>
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_offer_letters')"  >
              <div class="form_group">
            <label class="form_label">{{('offerLetter')|formatdoctype}} </label>
            <file-upload :disabled="true" v-model="documents.offerLetter" class="file-upload-input" 
              name="offerLetter" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.offerLetter )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('offerLetter')">{{ errors.first("offerLetter") }}</span>
              </div>
            <ul  class="uploaded-list">
              <template v-for="(item, index) in documents.offerLetter">
              <vs-chip @click="remove(item, documents.offerLetter)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
            </div>
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_employment_agreement')" >
            <div class="form_group">
            <label class="form_label">{{('employmentAgreement')|formatdoctype}} </label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
           </div>

            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_exp_letters')">
              <div class="form_group">
              <label class="form_label">Experience Letters</label>
              <file-upload :disabled="true" v-model="documents.expLetters" class="file-upload-input" 
              name="experienceDocument"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                data-vv-as="Experience Letters" :multiple="true" @input="upload(documents.expLetters)">
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('experienceDocument')">{{ errors.first("experienceDocument") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.expLetters" >
                <vs-chip @click="remove(item, documents.expLetters)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="Experience Letters" /> -->
            </div>
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_ins_notices')" >
              <div class="form_group">
              <label class="form_label">{{ 'INSNotices' | formatdoctype }}</label>
              <file-upload :disabled="true" v-model="documents.INSNotices" class="file-upload-input"
                name="insNoticeDocument" data-vv-as="INS Notices" :multiple="true"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @input="upload(documents.INSNotices)" >
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('insNoticeDocument')">{{ errors.first("insNoticeDocument") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.INSNotices">
                <vs-chip @click="remove(item, documents.INSNotices)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="INS Notices" /> -->
            </div>
            
            
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_form_i20_ead')">
              <div class="form_group">
              <label class="form_label">{{ 'formI20' | formatdoctype }}</label>
              <file-upload :disabled="true" v-model="documents.formI20" class="file-upload-input" 
                name="formI20Document" data-vv-as="INS Notices" :multiple="true"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                @input="upload(documents.formI20)" >
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('formI20Document')">{{ errors.first("formI20Document") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.formI20">
                <vs-chip @click="remove(item, documents.formI20)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
            </div>

            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_I797NoticeofApprovalforI140')">
              <div class="form_group">
              <label class="form_label">{{ 'I797NoticeofApprovalforI140' | formatdoctype }}</label>
              <file-upload :disabled="true" v-model="documents.I797NoticeofApprovalforI140" class="file-upload-input" 
                name="docs_I797NoticeofApprovalforI140" data-vv-as="I-79Notice of Approval for I-140" :multiple="true"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                @input="upload(documents.I797NoticeofApprovalforI140)" >
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('I797NoticeofApprovalforI140')">{{ errors.first("I797NoticeofApprovalforI140") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.I797NoticeofApprovalforI140">
                <vs-chip @click="remove(item, documents.I797NoticeofApprovalforI140)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                </template>
              </ul>
            </div>

            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_ssc_licence')"  >
              <div class="form_group">
              <label class="form_label">Social security card and state professional license</label>
              <file-upload :disabled="true" v-model="documents.socialSecurityCardAndProfLicense" class="file-upload-input"
                name="socialSecurityCardAndProfLicenseDocument" data-vv-as="INS Notices" :multiple="true"
                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @input="upload(documents.socialSecurityCardAndProfLicense)">
                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
              </file-upload>
              
              <span class="text-danger text-sm"
              v-show="errors.has('socialSecurityCardAndProfLicenseDocument')">{{ errors.first("socialSecurityCardAndProfLicenseDocument") }}</span>
              </div>
              <ul  class="uploaded-list">
                <template v-for="(item, index) in documents.socialSecurityCardAndProfLicense">
                <vs-chip @click="remove(item, documents.socialSecurityCardAndProfLicense)"  v-if="item.status !== false" :key="index" closable> {{ item.name }} </vs-chip>
                </template>
              </ul>
              <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload" data-vv-as="Social security card and state professional license" /> -->
            </div>
              

            

            <!----NEW DOCUMENTS--->

            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_paystubs')" >
              <div class="form_group">
            <label class="form_label">Three Recent Pay Stubs</label>
            <file-upload :disabled="true" v-model="documents.payStubs" class="file-upload-input" 
              name="payStubs" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.payStubs )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('payStubs')">{{ errors.first("payStubs") }}</span>
              </div>
            <ul  class="uploaded-list">
            <template v-for="(item, index) in documents.payStubs">
              <vs-chip @click="remove(item, documents.payStubs)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
            </template>
            </ul>
            </div>

            
              <!-- Client Letters -->
            <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_client_letters')"  >
              <div class="form_group">
            <label class="form_label">{{'clientLetter' | formatdoctype}}</label>
            <file-upload :disabled="true" v-model="documents.clientLetter" class="file-upload-input" 
              name="clientLetter" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.clientLetter )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('clientLetter')">{{ errors.first("clientLetter") }}</span>
              </div>
            <ul  class="uploaded-list">
            <template v-for="(item, index) in documents.clientLetter">
              <vs-chip @click="remove(item, documents.clientLetter)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
            </template>
            </ul>
            </div>
          
          
          <!--vendorLetter--->
          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_vendor_letters')" >
            <div class="form_group">
            <label class="form_label">{{'vendorLetter'| formatdoctype}}</label>
            <file-upload :disabled="true" v-model="documents.vendorLetter" class="file-upload-input" 
              name="vendorLetter" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.vendorLetter )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('vendorLetter')">{{ errors.first("vendorLetter") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.vendorLetter" >
              <vs-chip @click="remove(item, documents.vendorLetter)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
            </template>
            </ul>
          </div>


          <!--msa--->
          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_msa')" >
            <div class="form_group">
            <label class="form_label">{{'msa'| formatdoctype}}</label>
            <file-upload :disabled="true" v-model="documents.msa" class="file-upload-input" 
              name="msa" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.msa )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('msa')">{{ errors.first("msa") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template v-for="(item, index) in documents.msa" >
              <vs-chip @click="remove(item, documents.msa)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>

            <!--po--->
          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_po')" >
            <div class="form_group">
            <label class="form_label">PO</label>
            <file-upload :disabled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>

          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_h1b_reg_selection_notice')" >
            <div class="form_group">
            <label class="form_label">{{'h1bRegSelectionNotice' | formatdoctype}}</label>
            <file-upload :disabled="true" :disadled="true"  v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>

          
          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_prime_vendor')" >
            <div class="form_group">
            <label class="form_label">{{ 'primeVendor'| formatdoctype }}</label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>


          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_form_i94')" >
            <div class="form_group">
            <label class="form_label">I94</label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>
           <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_prior_form_i797')" >
            <div class="form_group">
            <label class="form_label">{{'priorFormI797'| formatdoctype}}</label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>




                  
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgResume')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgResume' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgCollegeDegreesCert')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgCollegeDegreesCert' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgTransScripts')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgTransScripts' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgExpLetters')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgExpLetters' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgPassportAndVisa')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgPassportAndVisa' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>

        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgI94')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgI94' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgPrevNonimmApprovalNotices')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgPrevNonimmApprovalNotices' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgI140OrPermNoties')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgI140OrPermNoties' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgPrevLaborApplications')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgPrevLaborApplications' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgAckOfPrevLaborApplications')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgAckOfPrevLaborApplications' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgPaystubs')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgPaystubs' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgI20')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgI20' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>
        <div class="vx-col w-full marb20" v-if="checkTemplateField('slgEad')">
          <div class="form_group">
          <label class="form_label">SLG - {{'slgEad' | formatdoctype}}</label>
          <file-upload :disabled="true" v-model="documents.resume" class="file-upload-input"
          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            name="resumeDocument" data-vv-as="Resume" :multiple="true"
            @input="upload(documents.resume)" >
            <img class="file-icon" src="@/assets/images/main/file-upload.svg">
            Upload
          </file-upload>                    
          <span class="text-danger text-sm"
          v-show="errors.has('resumeDocument')">{{ errors.first("resumeDocument") }}</span>
          </div>
          <ul  class="uploaded-list">
          <template v-for="(item, index) in documents.resume">
          <vs-chip @click="remove(item, documents.resume)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
          </template>
          </ul>
          
        </div>



         

              <!----NEW DOCUMENTS END--->

          <div class="vx-col w-full marb20" v-if="checkTemplateField('docs_other')" >
            <div class="form_group">
          <label class="form_label">Other documents, if any</label>
          <file-upload :disabled="true" v-model="documents.other" class="file-upload-input"
            name="otherDocument" data-vv-as="INS Notices" :multiple="true"
            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            @input="upload(documents.other)">
            <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
          </file-upload>

          <span class="text-danger text-sm"
          v-show="errors.has('otherDocument')">{{ errors.first("otherDocument") }}</span>
            </div>
          <ul  class="uploaded-list">
            <template v-for="(item, index) in documents.other">
            <vs-chip @click="remove(item, documents.other)"  v-if="item.status !== false" :key="index" closable> {{ item.name }} </vs-chip>
            </template>
          </ul>
          <!-- <vs-upload text="Upload" class="file-upload" action="https://jsonplaceholder.typicode.com/posts/"
            @on-success="successUpload" data-vv-as="Social security card and state professional license" /> -->
          </div>


          </div>
        </div>
      </vs-col>
      <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
          icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
      </div>
    </div>
    </div>  
  </div> 
  <div v-if="(checkTemplateField('marital_status')) && ( checkTemplateField('child_h4_required') || checkTemplateField('spouse_h4_required') )"  >
        <div class="block_title pb-0">
          Spouse Info
        </div> 
        <div class="form-container w-full questionnairesection ">
            <form data-vv-scope="dependentsInfoform" @submit.prevent="" @keydown.enter.prevent="">

              <!-- <vs-col class="w-full p-0">
                <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal"
                  icon="IP-information-button" active="true">
                  <p>
                    Your spouse and children will need to apply for H-4 status (only if they are currently in the USA on a
                    valid status).
                  </p>
                  <p>
                    That their status must be extended through a separate application, and is not automatically extended
                    upon approval of the H-1B petition.
                  </p>
                </vs-alert>
              </vs-col> -->
              
            <!--<div  class="spousedetails" v-if="beneficiaryInfo.maritalStatus == 2">-->
              <div  class="spousedetails" >
              <vs-col class="m-auto pt-6 float-none" vs-type="flex" vs-sm="12" v-if="checkTemplateField('spouse_h4_required')">
                <div class="alert-content-block">
                  <p>H4 required for spouse?</p>
                  <div class="form_radio_btns">
                    <vs-button :disabled="true" class="yes mr-5" v-bind:class="{
                      cactive: dependentsInfo.spouse.h4Required == true
                    }" @click="dependentsInfo.spouse.h4Required = true" color="success" type="border">Yes</vs-button>
                    <vs-button :disabled="true"  class="no" v-bind:class="{
                      cactive: dependentsInfo.spouse.h4Required == false
                    }" @click="dependentsInfo.spouse.h4Required = false" color="danger" type="border">No </vs-button>
                  </div>
                </div>
              </vs-col>

              <template  v-if="checkTemplateField('spo_priorPeriodOfStayInUS')" >

              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
              <div class="form-container">
              <div class="vx-row">
                <div class="vx-col w-full mt-6">
                  <p>All prior periods of stay in the U.S. over the last seven years</p>
                </div>

                <div class="vx-col w-full">

                  <div class="vx-row delete-row" v-for="(priorstay, index) in priorPeriodOfStayInUS" :key="priorstay.id">
                    <div class="vx-col md:w-1/3 w-full">
                      <div class="form_group">
                      <label class="form_label">Date Entered</label>
                      <div class="main-placeholder right">
                        <datepicker  :typeable="true" data-vv-as="Date Entered" :name="'enterDate'+index" 
                        :disabled-dates="{to: new Date(startBeneficiaryDateEntered), from: new Date()}" v-model="priorstay.enteredDate"
                          placeholder="MM/DD/YYYY"></datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.enterDate'+index)">{{ errors.first('beneficiaryInfoform.enterDate'+index)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                      <div class="form_group">
                      <label class="form_label">Date Departed</label>
                      <div class="main-placeholder right">

                        <datepicker  :typeable="true"  :name="'departDate'+index" v-validate="{required: priorstay.enteredDate != null && !priorstay.departedDate }" data-vv-as="Date Departed"
                        :disabled="priorstay.enteredDate === null" :disabled-dates="{to: priorstay.enteredDate, from: new Date()}" v-model="priorstay.departedDate"
                          placeholder="MM/DD/YYYY"></datepicker>
                          <span class="text-danger text-sm"
                            v-show="errors.has('beneficiaryInfoform.departDate'+index)">{{ errors.first('beneficiaryInfoform.departDate'+index) }}</span>
                            </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                          <div class="form_group">
                            <label class="form_label">Case Status</label>
                            <multiselect name="VisaStatus"   v-model="bncountryModel" :disabled="true "
                            @select="selectCountry" :show-labels="false" ref="VisaStatus" track-by="id" label="Visa Status" data-vv-as="Visa Status"
                            placeholder="Visa Status" :options="visastatuses" :searchable="true" :allow-empty="false">
                          </multiselect>


                    
                      <span class="text-danger text-sm" 
                        v-show="errors.has('beneficiaryInfoform.selectVisaStatus'+index)">{{ errors.first('beneficiaryInfoform.selectVisaStatus'+index)}}</span>
                    </div>
                    </div>
                    <div class="delete" v-if="priorPeriodOfStayInUS.length > 1">
                      <a @click="removepriorstay(index)">
                        <img src="@/assets/images/main/delete-row-img.svg">
                      </a>
                    </div>
                  </div>
                </div>

              </div>
              </div>

              </vs-col>
              <vs-col class="m-auto float-none" vs-type="flex" vs-align="center" vs-sm="12">
              <a :disabled="true"   class="add-more ml-0" type="filled">
              <span>+</span> More
              </a>
              </vs-col>
              </template>  

              <div   v-if="dependentsInfo.spouse.h4Required && dependentsInfo.spouse.h4Required == true && checkTemplateField('spouse_h4_required')"  > 

              <div class="divider" v-if="dependentsInfo.spouse.h4Required && dependentsInfo.spouse.h4Required == true && checkTemplateField('spouse_h4_required')">
              </div>
              <vs-col v-if="dependentsInfo.spouse.h4Required && dependentsInfo.spouse.h4Required == true && checkTemplateField('spouse_h4_required') && checkTemplateField('spouse_h4_ead_required')"
                class="m-auto float-none" vs-type="flex" vs-sm="12">
                <div class="alert-content-block">
                  <p>H4 EAD required for spouse?</p>
                  <div class="form_radio_btns">
                    <vs-button :disabled="true"  v-bind:class="{
                      cactive: dependentsInfo.spouse.h4Required === true && dependentsInfo.spouse.h4EADRequired === true
                    }" @click="setH4EADValue(dependentsInfo.spouse.h4Required, true)" class="yes mr-5" color="success" type="border">Yes
                    </vs-button>
                    <vs-button :disabled="true"  class="no" v-bind:class="{
                      cactive: dependentsInfo.spouse.h4Required === true && dependentsInfo.spouse.h4EADRequired === false
                    }" @click="setH4EADValue(dependentsInfo.spouse.h4Required, false)" color="danger" type="border">No</vs-button>
                  </div>
                </div>
                
              </vs-col>
              <div class="divider" v-if="checkTemplateField('spouse_first_name') ||  checkTemplateField('spouse_middle_name') ||  checkTemplateField('spouse_last_name')
              || checkTemplateField('spouse_email') || checkTemplateField('spouse_phone_number') || checkTemplateField('spouse_dob') || checkTemplateField('spouse_cob') || checkTemplateField('spouse_provinceOfBirth')
               || checkTemplateField('spouse_locationOfBirth')
            "></div>
              
              <template v-if="checkTemplateField('spouse_first_name') ||  checkTemplateField('spouse_middle_name') ||  checkTemplateField('spouse_last_name')
              || checkTemplateField('spouse_email') || checkTemplateField('spouse_phone_number') || checkTemplateField('spouse_dob') || checkTemplateField('spouse_cob') || checkTemplateField('spouse_provinceOfBirth')
              || checkTemplateField('spouse_locationOfBirth')
              
              ">
              <vs-col   class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12"  >
                <div class="form-container">
                  <div class="vx-row">
                    <template v-if="checkTemplateField('spouse_first_name') ||  checkTemplateField('spouse_middle_name') ||  checkTemplateField('spouse_last_name')" >
                        <div class="vx-col w-full">
                          
                          <vx-input-group class="form-input-group"  >
                            <div class="form_group w-full" v-if="checkTemplateField('spouse_first_name')" >
                              <label class="form_label">First Name</label>
                              <vs-input class="w-full" data-vv-as="First Name" name="firstName"
                                v-model="dependentsInfo.spouse.firstName" />
                            </div>
                            <div class="form_group w-full"  v-if="checkTemplateField('spouse_middle_name')">
                              <label class="form_label">Middle Name</label>
                              <vs-input class="w-full" data-vv-as="Middle Name" name="middleName"
                                v-model="dependentsInfo.spouse.middleName"  />
                            </div>
                            <div class="form_group w-full" v-if="checkTemplateField('spouse_last_name')" >
                              <label class="form_label">Last Name</label>
                              <vs-input class="w-full" data-vv-as="Last Name" name="lastName"
                                v-model="dependentsInfo.spouse.lastName"  />
                            </div>
                          </vx-input-group>

                          <!-- <div class="input-group-error">
                            <p class="w-1/3">
                              <span class="text-danger text-sm"
                                v-show="errors.has('dependentsInfoform.firstName')">{{ errors.first("dependentsInfoform.firstName") }}</span>
                            </p>
                            <p class="w-1/3"></p>
                            <p class="w-1/3">
                              <span class="text-danger text-sm"
                                v-show="errors.has('dependentsInfoform.lastName')">{{ errors.first("dependentsInfoform.lastName") }}</span>
                            </p>
                          </div> -->
                          
                        </div>
                    </template>
                    <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('spouse_email')" >
                      <div class="form_group">
                        <label class="form_label">Spouse Email</label>
                        <vs-input name="Spouse Email" v-model="dependentsInfo.spouse.email"    class="w-full"
                          data-vv-as="Spouse Email"  />
                          <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfo.spouse.email')">{{ errors.first("dependentsInfo.spouse.email") }}</span>
                      </div>
                    </div>

                  <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_phone_number')">
                  <div class="form_group ph_number">
                      
                        <label for="" class="form_label">Spouse Phone Number</label>
                        <vs-input
                          v-mask="'(###)-###-####'"
                          v-model="dependentsInfo.spouse.phoneNumber"
                          name="spousePhoneNumber"
                          v-validate="'required|phonevalid'"
                          data-vv-as="Phone Number"
                          placeholder="(XXX)-XXX-XXXX"
                          wrapperClass="vs-con-input"
                          class="w-full"
                          inputClass="vs-inputx vs-input--input normal"/>
                       

                    <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfo.spouse.phoneNumber')">{{ errors.first("dependentsInfo.spouse.phoneNumber") }}</span>
                  </div> 
                  </div>   

                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_dob')" >
                      
                      <div class="form_group">
                        <label class="form_label">Spouse’s Date of Birth</label>
                        <datepicker  :typeable="true" name="dateofbirth" :open-date="new Date(startEligibleDate)" :disabled-dates="{from: new Date(startEligibleDate)}"  
                          v-model="dependentsInfo.spouse.dateOfBirth" data-vv-as="Spouse’s Date of Birth"
                          placeholder="MM/DD/YYYY"></datepicker>
                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.dateofbirth')">{{ errors.first("dependentsInfoform.dateofbirth") }}</span>

                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_cob')" >
                      <div class="form_group">
                        <label for class="form_label">Country of Birth</label>
                        <div class="con-select w-full">                          
                          <multiselect  ref="spousecountry" name="country"   v-model="countrySelected"
                            @select="selectspouseCountry" :show-labels="false" track-by="id" label="name"
                            data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                            :allow-empty="false"></multiselect>
                        </div>
                      <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.country')">{{ errors.first("dependentsInfoform.country") }}</span>
                    </div>
                     </div>

                     <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_cob') && checkTemplateField('spouse_provinceOfBirth')" >
                      <div class="form_group">
                        <label for class="form_label">Province of Birth</label>
                        <div class="con-select w-full">                          
                          <multiselect  ref="spousecountry" name="country"   v-model="countrySelected"
                            @select="selectspouseCountry" :show-labels="false" track-by="id" label="name"
                            data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                            :allow-empty="false"></multiselect>
                        </div>
                      <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.country')">{{ errors.first("dependentsInfoform.country") }}</span>
                    </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_cob') && checkTemplateField('spouse_locationOfBirth')" >
                      <div class="form_group">
                        <label for class="form_label">Location of Birth</label>
                        <div class="con-select w-full">                          
                          <vs-input :disabled="true" class="w-full" data-vv-as="Location of Birth"  placeholder="Location of Birth"
                                      name="locationOfBirth"  />
                        </div>
                      <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.country')">{{ errors.first("dependentsInfoform.country") }}</span>
                    </div>
                     </div>
                     

                  </div>
                </div>
              </vs-col>
              <div class="divider" v-if="checkTemplateField('spouse_passport_number') || checkTemplateField('spouse_passport_expiry_date') "></div>
              </template>

            <template v-if="checkTemplateField('spouse_passport_number') || checkTemplateField('spouse_passport_expiry_date') ">
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if="checkTemplateField('spouse_passport_number') ">
                    <div class="form_group">
                      <label class="form_label">Spouse’s Passport No</label>
                      <vs-input  data-vv-as="Spouse Passport Number"  name="spousepassport" v-model="dependentsInfo.spouse.passportNumber"  v-validate="'passport:spousecountry|max:12'"  class="w-full" />
                      <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.spousepassport')">{{ errors.first("dependentsInfoform.spousepassport") }}</span>
                    </div>
                    </div>

                    <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if=" checkTemplateField('spouse_passport_expiry_date') " >
                      
                      <div class="form_group">
                        <label class="form_label">Passport Expiry Date</label>
                        <datepicker  :typeable="true" v-model="dependentsInfo.spouse.passportExpiryDate" data-vv-as="Passport expiry date"
                          placeholder="MM/DD/YYYY"></datepicker>
                      </div>
                    </div>


                  </div>
                </div>
              </vs-col>
              <div class="divider" v-if="checkTemplateField('spouse_i94') || checkTemplateField('spouse_country_of_citizenship')"></div>
            </template>

            <template v-if="checkTemplateField('spouse_i94') || checkTemplateField('spouse_country_of_citizenship')">
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">

                    <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if="checkTemplateField('spouse_i94') "> 
                    <div class="form_group">
                        <label class="form_label">Spouse’s I-94</label>
                      <vs-input v-model="dependentsInfo.spouse.I94" class="w-full"  />
                    </div>
                    </div>

                    <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if=" checkTemplateField('spo_I94ExpiryDate') " >
                      
                      <div class="form_group">
                        <label class="form_label">I-94 Expiry Date</label>
                        <datepicker  :typeable="true" v-model="dependentsInfo.spouse.passportExpiryDate" data-vv-as="Passport expiry date"
                          placeholder="MM/DD/YYYY"></datepicker>
                      </div>
                    </div>

                    

                    <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if="checkTemplateField('spouse_country_of_citizenship') " >
                      <div class="form_group">
                        <label for class="form_label">Country of Citizenship</label>
                        <div class="con-select w-full">                        
                          <multiselect  ref="spousecountry" name="citizenship"   v-model="countryOfCitizenshipSelected"
                            @select="selectspousecountryOfCitizenship" :show-labels="false" track-by="id" label="name"
                            data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                            :allow-empty="false"></multiselect>
                        </div>
                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.citizenship')">{{ errors.first("dependentsInfoform.citizenship") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>

            <template v-if="checkTemplateField('spouse_current_status') || checkTemplateField('spouse_status_expiry_date') 
            || checkTemplateField('spouse_ssn') || checkTemplateField('spouse_date_of_last_arrival')" >
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_current_status') " >
                      <div class="form_group">
                        <label class="form_label">Spouse’s current status</label>
                        <vs-input  data-vv-as="Spouse’s current status"  name="Spouses_current_status" v-model="dependentsInfo.spouse.currentStatus"   class="w-full"
                           />
                      </div>
                      <!-- <span class="text-danger text-sm"  v-show="errors.has('dependentsInfo.spouse.currentStatus')">{{ errors.first("dependentsInfo.spouse.currentStatus") }}</span>
                    -->
                    </div>

                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_status_expiry_date')">                      
                      <div class="form_group">
  <!-- v-model="dependentsInfo.spouse.statusExpiryDate"  -->
                        <label class="form_label">When does spouse’s status expires</label>
                        <datepicker  :typeable="true"  v-model="dependentsInfo.spouse.statusExpiryDate" data-vv-as="Spouse’s status expires" placeholder="MM/DD/YYYY"></datepicker>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full  "  v-if="checkTemplateField('spouse_ssn')" >
                    
                      <div class="form_group">
                        <label for="" class="form_label">Spouse’s social security (if Any)</label>
                        <div class="vs-con-input">
                        <the-mask v-validate="'min:9|max:9'" v-model="dependentsInfo.spouse.SSN"
                          placeholder="123 - 45 - 6789" class="vs-inputx vs-input--input normal"
                          :mask="['### - ## - ####']" />
                        </div>
                      </div>
                      <!-- <the-mask v-validate="'min:9|max:9'" v-model="dependentsInfo.spouse.SSN"
                        placeholder="123 - 45 - 6789" class="vs-inputx vs-input--input normal"
                        :mask="['### - ## - ####']" /> -->
                      
                    </div>
                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_date_of_last_arrival')">
                      
                      <div class="form_group">
                        <label class="form_label">Date of last arrival </label>
                        <datepicker  :typeable="true"  v-model="dependentsInfo.spouse.lastArrivalDate"  data-vv-as="Date of last arrival" :disabled-dates="{from: new Date()}" placeholder="MM/DD/YYYY"></datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <div class="divider"></div>
            </template>  

            <template v-if="checkTemplateField('spouse_address_line2') || checkTemplateField('spouse_address_line1') 
            || checkTemplateField('spouse_address_country') || checkTemplateField('spouse_address_state') 
            || checkTemplateField('spouse_address_city') || checkTemplateField('spouse_address_zipcode')">        
              <vs-col class="m-auto float-none" vs-sm="12">
                <div class="form-container">
                  <h3 class="small-header">Physical Address</h3>
                  <div class="vx-row">

                  <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_address_line2')"> 
                  <div class="form_group">
                    <label class="form_label">Street Address</label>
                      <vs-input   name="address2" v-model="dependentsInfo.spouse.physicalAddress.line2" class="w-full"
                        data-vv-as="Street Address"/>
                      <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.address2')">{{ errors.first("dependentsInfoform.address2") }}</span>
                    </div>
                  </div>

                    <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('spouse_address_line1')">
                    <div class="form_group">
                      <label class="form_label">Apt, Suite</label>
                      <vs-input   name="address1" v-model="dependentsInfo.spouse.physicalAddress.line1" class="w-full"
                        data-vv-as="Apt, Suite" />
                      <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.address1')">{{ errors.first("dependentsInfoform.address1") }}</span>
                    </div>
                    </div>
                  
                    <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('spouse_address_country')"  >
                      <div class="form_group">
                        <label for class="form_label">Country</label>
                        <div class="con-select w-full  ">
                          
                          <multiselect name="spouseaddresscountry"   v-model="spouseaddresscountryModel"
                            @select="selectspouseaddressCountry" :show-labels="false" track-by="id" label="name"
                            data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                            :allow-empty="false"></multiselect>
                        </div>

                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.spouseaddresscountry')">{{ errors.first("dependentsInfoform.spouseaddresscountry") }}</span>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('spouse_address_state')">
                      <div class="form_group">
                        <label for class="form_label">State</label>
                        <div class="con-select w-full">                        
                          <multiselect name="spouseaddressstate"   v-model="spouseaddressstateModel"
                            @select="selectspouseaddressState" :show-labels="false" track-by="id" label="name" data-vv-as="State"
                            placeholder="Select State" :options="suposestates" :searchable="true" :allow-empty="false">
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.spouseaddressstate')">{{ errors.first("dependentsInfoform.spouseaddressstate") }}</span>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('spouse_address_city')">
                      <div class="form_group">
                        <label for class="form_label">City</label>
                        <div class="con-select w-full">
                          
                          <multiselect name="spouseaddresscity"   v-model="spouseaddresslocationModel"
                            @select="selectspouseaddresstLocation" :show-labels="false" track-by="id" label="name" data-vv-as="City"
                            placeholder="Select City" :options="souuselocations" :searchable="true" :allow-empty="false">
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.spouseaddresscity')">{{ errors.first("dependentsInfoform.spouseaddresscity") }}</span>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('spouse_address_zipcode')">
                      <div class="form_group">
                        <label for class="form_label">Zip Code</label>
                        <vs-input name="zipcode" v-model="dependentsInfo.spouse.physicalAddress.zipcode"
                          v-validate="'numeric|required|min:5|max:6'" class="w-full" data-vv-as="Zip Code"  />

                        <span class="text-danger text-sm"
                          v-show="errors.has('dependentsInfoform.zipcode')">{{ errors.first("dependentsInfoform.zipcode") }}</span>
                      </div>
                    </div>

                    <div class="vx-col md:w-1/2 w-full">

                    </div>
                  </div>
                </div>

              </vs-col>
              <div class="divider"></div>
            </template>
          
            <template v-if="checkTemplateField('spouse_docs_passport') || checkTemplateField('spouse_docs_visa') ||checkTemplateField('spouse_docs_formi94') 
          ||  checkTemplateField('spouse_docs_form_i797') || checkTemplateField('spouse_docs_mrg_certificate')
            || checkTemplateField('spouse_docs_other')
            || checkTemplateField('spouse_docs_noticeOfApprovalOfH1Status')
            || checkTemplateField('spouse_docs_approvalNoticeOfPrevH4')
            " >
              <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12">
                <div class="form-container w-full">
                  <div class="alert-content-block mb-2">
                    <vs-alert active="true" class="h-auto warning-alert" icon-pack="IntakePortal"
                      icon="IP-information-button">
                      Provide copies of the following spouse documents: <span>Case, Form I-94, Form I-797, Marriage Certificate</span>
                    </vs-alert>
                  </div>
                  <h3 class="small-header">
                    Spouse Documents
                    <span class="file-type">
                      (File Type: PDF, DOC, JPEG, PNG. Max
                      file size: 1MB)
                    </span>
                  </h3>
                  <div class="vx-row">
                    <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_passport')" >
                      <div class="form_group ">
                        <label class="form_label">{{ 'passport'| formatdoctype}}</label>
                        <!-- check balu 1 -->
                        <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.passport"
                          class="file-upload-input" name="passport" 
                          data-vv-as="Passport" :multiple="true"
                          accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          @input="upload(dependentsInfo.spouse.documents.passport)">
                            <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                            Upload
                        </file-upload>
                          <span class="text-danger text-sm"
                        v-show="errors.has('dependentsInfoform.passport')">{{ errors.first("dependentsInfoform.passport") }}</span>
                        </div>
                      <ul class="uploaded-list">
                      <template v-for="(item, index) in dependentsInfo.spouse.documents.passport">
                        <vs-chip type="button" @click="remove(item, dependentsInfo.spouse.documents.passport)"  :key="index" v-if="item.status !== false" closable>{{ item.name }} </vs-chip>
                      </template>
                      </ul>
                    </div>
                    
                    <div class="vx-col w-full marb20"  v-if="checkTemplateField('spouse_docs_visa')" >
                      <div class="form_group ">
                      <label class="form_label">{{'visa' | formatdoctype}}</label>
                      <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.visa" 
                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="file-upload-input" name="visa" data-vv-as="Visa" 
                      :multiple="true" @input="upload(dependentsInfo.spouse.documents.visa)" >
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                        Upload 
                      </file-upload>
                      
                      <span class="text-danger text-sm"
                    v-show="errors.has('visa')">{{ errors.first("visa") }}</span>
                      </div>
                      <ul class="uploaded-list">
                      <template v-for="(item, index) in dependentsInfo.spouse.documents.visa">
                        <vs-chip @click="remove(item, dependentsInfo.spouse.documents.visa)"  :key="index" closable v-if="item.status === true"> {{ item.name }} </vs-chip>
                      </template> 
                      </ul>
                    </div>
                    <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_formi94')">
                      <div class="form_group ">
                      <label class="form_label">{{'formI94' | formatdoctype}}</label>
                      <!-- check balu 2 -->
                      <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.formI94" 
                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="file-upload-input" name="formi94" data-vv-as="Form I-94" 
                      :multiple="true" @input="upload(dependentsInfo.spouse.documents.formI94)" >
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                        Upload 
                      </file-upload>
                      
                      <span class="text-danger text-sm"
                    v-show="errors.has('formi94')">{{ errors.first("formi94") }}</span>
                      </div>
                      <ul  class="uploaded-list">
                        <template v-for="(item, index) in dependentsInfo.spouse.documents.formI94">
                        <vs-chip @click="remove(item, dependentsInfo.spouse.documents.formI94)"  :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
                        </template>
                      </ul>
                      <!-- <vs-upload text="Upload" class="file-upload" data-vv-as="Form I-94"
                        action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" /> -->
                    </div>
                    <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_form_i797')">
                      <div class="form_group ">
                      <label class="form_label">Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)</label>
                      <!-- check balu 3 -->
                      <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.formI797" 
                      class="file-upload-input" name="formi797" data-vv-as="Form I-797" 
                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :multiple="true" @input="upload(dependentsInfo.spouse.documents.formI797)">
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                          Upload 
                      </file-upload>
                      
                      <span class="text-danger text-sm"
                    v-show="errors.has('formi797')">{{ errors.first("formi797") }}</span>
                      </div>
                      <ul  class="uploaded-list">
                        <template v-for="(item, index) in dependentsInfo.spouse.documents.formI797">
                        <vs-chip @click="remove(item, dependentsInfo.spouse.documents.formI797)"  :key="index" closable v-if="item.status === true"> {{ item.name }} </vs-chip>
                        </template>
                      </ul>
                      
                    </div>
                    <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_mrg_certificate')">
                      <div class="form_group ">
                      <label class="form_label">Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status)</label>
                      <!-- check balu 4 --> 
                      <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.marriageCertificate" 
                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="file-upload-input" name="marriageCertificate" data-vv-as="Marriage Certificate" 
                      :multiple="true"  @input="upload(dependentsInfo.spouse.documents.marriageCertificate)" >
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                        Upload 
                      </file-upload>
                      
                      <span class="text-danger text-sm"
                    v-show="errors.has('marriageCertificate')">{{ errors.first("marriageCertificate") }}</span>
                      </div>
                      <ul  class="uploaded-list">
                        <template  v-for="(item, index) in dependentsInfo.spouse.documents.marriageCertificate">
                        <vs-chip @click="remove(item, dependentsInfo.spouse.documents.marriageCertificate)" :key="index" closable v-if="item.status === true"> {{ item.name }} </vs-chip>
                        </template>
                      </ul>
                      <!-- <vs-upload text="Upload" class="file-upload" data-vv-as="Marriage Certificate"
                        action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" /> -->
                    </div>
                     <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_form_i20')" >
            <div class="form_group">
            <label class="form_label">{{'formI20' | formatdoctype}}</label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="po" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-sm-doc"
            v-show="errors.has('po')">{{ errors.first("po") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>
           <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_pay_stubs')" >
            <div class="form_group">
            <label class="form_label">Three recent pay stubs (if spouse is on H-1B or L-1 status)</label>
            <file-upload :disabled="true" :disadled="true" v-model="documents.po" class="file-upload-input" 
              name="spouse_docs_pay_stubs" data-vv-as="INS Notices" :multiple="true"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
              @input="upload(documents.po )" >
              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
            </file-upload>
            
            <span class="text-danger text-doc"
            v-show="errors.has('spouse_docs_pay_stubs')">{{ errors.first("spouse_docs_pay_stubs") }}</span>
            </div>
            <ul  class="uploaded-list">
              <template  v-for="(item, index) in documents.po">
              <vs-chip @click="remove(item, documents.po)" :key="index" closable v-if="item.status !== false"> {{ item.name }} </vs-chip>
              </template>
            </ul>
          </div>

            <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_noticeOfApprovalOfH1Status')">
              <div class="form_group">
                <label class="form_label">{{'noticeOfApprovalOfH1Status' | formatdoctype }}</label> 
                <file-upload :disabled="true" v-model="children.documents.formI797" class="file-upload-input" 
                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    :name="'chilFormI797'+index" data-vv-as="Form I-797" :multiple="true"
                    @input="upload(children.documents.formI797, index)" >
                    <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                    Upload 
                  </file-upload>
                  <span class="text-danger text-sm"
                    v-show="errors.has('chilFormI797'+index)">{{ errors.first('chilFormI797'+index) }}</span>
              </div>
              <ul  class="uploaded-list">
                <template  v-for="(formI797, formI797Value) in children.documents.formI797">
                <vs-chip @click="remove(formI797, children.documents.formI797)" :name="'formI94RemoveSelected'+index" :key="formI797Value" v-if="formI797.status !== false" closable> {{ formI797.name }} </vs-chip>
                </template>
              </ul>
            </div>


            <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_approvalNoticeOfPrevH4')">
              <div class="form_group">
                <label class="form_label">{{'approvalNoticeOfPrevH4' | formatdoctype }}</label> 
                <file-upload :disabled="true" v-model="children.documents.formI797" class="file-upload-input" 
                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    :name="'chilFormI797'+index" data-vv-as="Form I-797" :multiple="true"
                    @input="upload(children.documents.formI797, index)" >
                    <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                    Upload 
                  </file-upload>
                  <span class="text-danger text-sm"
                    v-show="errors.has('chilFormI797'+index)">{{ errors.first('chilFormI797'+index) }}</span>
              </div>
              <ul  class="uploaded-list">
                <template  v-for="(formI797, formI797Value) in children.documents.formI797">
                <vs-chip @click="remove(formI797, children.documents.formI797)" :name="'formI94RemoveSelected'+index" :key="formI797Value" v-if="formI797.status !== false" closable> {{ formI797.name }} </vs-chip>
                </template>
              </ul>
            </div>

                    <div class="vx-col w-full marb20" v-if="checkTemplateField('spouse_docs_other')" >
                      <div class="form_group ">
                      <label class="form_label">Other documents, if any</label>
                      
                      <file-upload :disabled="true" v-model="dependentsInfo.spouse.documents.other" 
                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="file-upload-input" name="spouseOther" data-vv-as="Marriage Certificate" 
                      :multiple="true"  @input="upload(dependentsInfo.spouse.documents.other)" >
                        <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                        Upload 
                      </file-upload>
                      
                      <span class="text-danger text-sm"
                    v-show="errors.has('spouseOther')">{{ errors.first("spouseOther") }}</span>
                      </div>
                      <ul  class="uploaded-list">
                      <template v-for="(item, index) in dependentsInfo.spouse.documents.other">
                        <vs-chip @click="remove(item, dependentsInfo.spouse.documents.other)"  :key="index" closable v-if="item.status === true"> {{ item.name }} </vs-chip>
                      </template>
                      </ul>
                      
                    </div>
                  


                  </div>
                </div>
              </vs-col>
            </template>  
             </div>



            </div>
             <template v-if="checkTemplateField('child_h4_required')">
              <div class="block_title pb-0">
                 Children Info
             </div> 
              <div v-for="(children, index) in childrensarray" :key="children.id">
                <div class="divider divider-double"></div>
                <div class="delete-row delete-group" v-if="childrensarray.length > 1">
                  <div class="delete">
                    <a @click="removechildren(index)">
                      <img src="@/assets/images/main/delete-row-img.svg">
                    </a>
                  </div>
                </div>
                <vs-col class="m-auto float-none" vs-type="flex" vs-sm="12" v-if="checkTemplateField('child_h4_required')" >
                  <div class="alert-content-block">
                    <p>H4 required for children?</p>
                    <div class="form_radio_btns">
                    <vs-button v-bind:class="{
                    cactive: children.h4Required == true
                  }" @click="children.h4Required = true" class="yes mr-5" color="success" type="border">Yes</vs-button>
                    <vs-button class="no" v-bind:class="{
                    cactive: children.h4Required == false
                  }" @click="children.h4Required = false" color="danger" type="border">No</vs-button>
                  </div>
                  </div>
                </vs-col>
                  <div  v-if="children.h4Required == true " >
                  <template v-if=" ( checkTemplateField('child_first_name') || checkTemplateField('child_middle_name') || checkTemplateField('child_last_name') 
                  || checkTemplateField('child_dob') || checkTemplateField('child_country_of_birth') || checkTemplateField('child_passport_expiry_date')
                  || checkTemplateField('child_i94') ||  checkTemplateField('child_country_of_citizenship') || checkTemplateField('child_visa_status')
                  || checkTemplateField('child_status_expiry_date')
                  )"  >
                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center"
                      vs-sm="12">
                      <div class="form-container">
                        <div class="vx-row">
                          <div class="vx-col w-full"  v-if="checkTemplateField('child_first_name') || checkTemplateField('child_middle_name') || checkTemplateField('child_last_name')" >
                            <vx-input-group class="form-input-group" v-if="checkTemplateField('child_first_name')" >
                              <div class="form_group w-full">
                                <label class="form_label">First Name</label>
                                <vs-input   v-model="children.firstName" class="w-full"/>
                              </div>
                              <div class="form_group w-full" v-if=" checkTemplateField('child_middle_name')" >
                                <label class="form_label">Middle Name</label>
                                <vs-input   v-model="children.middleName" class="w-full"/>
                              </div>
                              <div class="form_group w-full" v-if="checkTemplateField('child_last_name')">
                                <label class="form_label">Last Name</label>
                                <vs-input   v-model="children.lastName" class="w-full"/>
                              </div>
                            </vx-input-group> 
                          </div>

                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_dob')">
                            <div class="form_group">
                              <label class="form_label">Child’s Date of Birth</label>                              
                              <datepicker  :typeable="true" v-model="children.dateOfBirth" :disabled-dates="{from: new Date()}" data-vv-as="Date of Birth" placeholder="MM/DD/YYYY">
                              </datepicker>                               
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_cob')"  >
                            <div class="form_group">
                              <label for class="form_label">Country of Birth</label>
                              <div class="con-select w-full">                              
                                <multiselect name="childcountry[]" :id="index" v-model="children.selectedcountryOfBirth" @select="selectchildCountry"
                                  :show-labels="false" track-by="id" label="name" data-vv-as="Country"
                                  placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                                </multiselect>
                              </div>
                            </div>


                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="checkTemplateField('child_passport_number')"  >
                            <div class="form_group">
                              <label class="form_label">Child’s Passport Number</label> 
                              <vs-input v-model="children.passportNumber" class="w-full"  />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_passport_expiry_date')" >                         

                            <div class="form_group">
                                <label class="form_label">Passport Expiry Date</label>
                                <datepicker  :typeable="true" v-model="children.passportExpiryDate" placeholder="MM/DD/YYYY"></datepicker>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_i94')" >
                            <div class="form_group">
                              <label class="form_label">Child’s I –94</label> 
                              <vs-input v-model="children.I94" class="w-full" />
                            </div>
                          </div>

                          <div class="vx-col lg:w-1/2 md:w-1/2 w-full" v-if=" checkTemplateField('child_i94_expiry_date') " >
                      
                            <div class="form_group">
                              <label class="form_label">I-94 Expiry Date </label>
                              <datepicker disabled="true" :typeable="true" data-vv-as="I-94 Expiry Date"
                                placeholder="MM/DD/YYYY"></datepicker>
                            </div>
                          </div>

                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_country_of_citizenship')" >
                            <div class="form_group">
                              <label for class="form_label">Country of Citizenship</label>
                              <div class="con-select w-full">
                                <multiselect name="childcitizenship[]" :id="index" v-model="children.selectedcitizenship" @select="selectchildCitizenship"
                                  :show-labels="false" track-by="id" label="name" data-vv-as="Country"
                                  placeholder="Select Country" :options="countries" :searchable="true" :allow-empty="false">
                                </multiselect>
                                </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_current_status')" >
                            <div class="form_group">
                              <label for class="form_label">Child’s Current Status</label>
                           

                            <multiselect name="VisaStatus"   v-model="bncountryModel" :disabled="checkCountry === false  "
                            @select="selectCountry" :show-labels="false" ref="VisaStatus" track-by="id" label="Visa Status" data-vv-as="Visa Status"
                            placeholder="Visa Status" :options="visastatuses" :searchable="true" :allow-empty="false">
                          </multiselect>
                            
                          </div>
                          </div>


                          <div class="vx-col md:w-1/2 w-full" v-if=" checkTemplateField('chi_provinceOfBirth')" >
                            <div class="form_group">
                              <label for class="form_label">Province of Birth</label>
                              <div class="con-select w-full">                          
                                <multiselect  ref="spousecountry" name="country"   v-model="countrySelected"
                                  @select="selectspouseCountry" :show-labels="false" track-by="id" label="name"
                                  data-vv-as="Country" placeholder="Select Country" :options="countries" :searchable="true"
                                  :allow-empty="false"></multiselect>
                              </div>
                            <span class="text-danger text-sm"
                              v-show="errors.has('dependentsInfoform.country')">{{ errors.first("dependentsInfoform.country") }}</span>
                          </div>
                           </div>
                           <div class="vx-col md:w-1/2 w-full" v-if=" checkTemplateField('chi_locationOfBirth')" >
                            <div class="form_group">
                              <label for class="form_label">Location of Birth</label>
                              <div class="con-select w-full">                          
                                <vs-input :disabled="true" class="w-full" data-vv-as="Location of Birth"  placeholder="Location of Birth"
                                            name="locationOfBirth"  />
                              </div>
                            <span class="text-danger text-sm"
                              v-show="errors.has('dependentsInfoform.country')">{{ errors.first("dependentsInfoform.country") }}</span>
                          </div>
                           </div>



                          <div class="vx-col md:w-1/2 w-full" v-if="checkTemplateField('child_status_expiry_date')" >
                            
                            <div class="form_group">
                              <label class="form_label">When does child’s status expires </label>
                              <datepicker  :typeable="true" v-model="children.statusExpiryDate" data-vv-as="Status expires"
                                placeholder="MM/DD/YYYY"></datepicker>
                            </div>
                          </div>

                       

                        </div>
                      </div>
                    </vs-col>
                    <div class="divider" v-if=" checkTemplateField('child_docs_passport') || checkTemplateField('child_docs_visa') 
                  || checkTemplateField('child_docs_form_i94')  || checkTemplateField('child_docs_form_i797')
                  || checkTemplateField('child_docs_birth_certificate') || checkTemplateField('child_docs_approval_notice')
                  || checkTemplateField('child_docs_other')
                  
                  || checkTemplateField('child_docs_approvalNoticeOfPrevH4') 
                  " ></div>
                  </template> 
                  <template v-if=" checkTemplateField('child_docs_passport') || checkTemplateField('child_docs_visa') 
                  || checkTemplateField('child_docs_form_i94')  || checkTemplateField('child_docs_form_i797') || checkTemplateField('child_docs_approvalNoticeOfPrevH4') 
                  || checkTemplateField('child_docs_birth_certificate') || checkTemplateField('child_docs_approval_notice')
                  || checkTemplateField('child_docs_other')" >
                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center"
                      vs-sm="12">
                      <div class="form-container w-full">
                        <div class="alert-content-block">
                          <vs-alert active="true" class="h-auto warning-alert mb-5" icon-pack="IntakePortal"
                            icon="IP-information-button">
                            Provide copies of the following children documents: <span>Case, Form I-94, Form I-797, Birth Certificate.</span>
                          </vs-alert>
                        </div>
                        <h3 class="small-header">
                          Child's Documents
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max
                            file size: 1MB)
                          </span>
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_passport')" >
                            <div class="form_group">
                              <label class="form_label">{{ 'passport'| formatdoctype}}</label>
                              <file-upload :disabled="true" v-model="children.documents.passport" class="file-upload-input"
                              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              :name="'childPassport'+index" data-vv-as="Passport" :multiple="true" 
                                @input="upload(children.documents.passport, index)" >
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> 
                                Upload
                              </file-upload>
                              <span class="text-danger text-sm"
                                v-show="errors.has('childPassport'+index)">{{ errors.first('childPassport'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <!-- child passport 1 -->
                              <template v-for="(passport, passportValue) in children.documents.passport">
                              <vs-chip @click="remove(passport, children.documents.passport)" :name="'passportRemoveSelected'+index"  :key="passportValue" close closable v-if="passport.status !== false"> {{ passport.name }} </vs-chip>
                              </template>
                            </ul>
                          </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_visa')" >
                            <div class="form_group">
                            <label class="form_label">Case</label>
                            <file-upload :disabled="true" v-model="children.documents.visa"
                            class="file-upload-input" accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            :name="'childVisa'+index" data-vv-as="Visa" :multiple="true"
                            @input="upload(children.documents.visa, index)" >
                            <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
                            </file-upload>
                            <span class="text-danger text-sm"
                              v-show="errors.has('childVisa'+index)">{{ errors.first('childVisa'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                            <template v-for="(visa, visaValue) in children.documents.visa">
                              <vs-chip @click="remove(visa, children.documents.visa)" :name="'visaRemoveSelected'+index"  :key="visaValue" closable v-if="visa.status !== false"> {{ visa.name }} </vs-chip>
                            </template>
                            </ul>
                          </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_form_i94')" >
                            <div class="form_group">
                              <label class="form_label">Form I-94 </label>
                              <file-upload :disabled="true" v-model="children.documents.formI94" class="file-upload-input" 
                              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                :name="'childFormI94'+index" data-vv-as="Form I-94" :multiple="true"
                                @input="upload(children.documents.formI94, index)" >
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                                Upload 
                              </file-upload>
                              <span class="text-danger text-sm"
                                v-show="errors.has('childFormI94'+index)">{{ errors.first('childFormI94'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <vs-chip @click="remove(formI94, children.documents.formI94)" :name="'formI94RemoveSelected'+index" v-for="(formI94, formI94Value) in children.documents.formI94" :key="formI94Value" v-if="formI94.status !== false" closable> {{ formI94.name }} </vs-chip>
                            </ul>
                          </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_form_i797')">
                            <div class="form_group">
                              <label class="form_label">Form I-797</label> 
                              <file-upload :disabled="true" v-model="children.documents.formI797" class="file-upload-input" 
                                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  :name="'chilFormI797'+index" data-vv-as="Form I-797" :multiple="true"
                                  @input="upload(children.documents.formI797, index)" >
                                  <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                                  Upload 
                                </file-upload>
                                <span class="text-danger text-sm"
                                  v-show="errors.has('chilFormI797'+index)">{{ errors.first('chilFormI797'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <template  v-for="(formI797, formI797Value) in children.documents.formI797">
                              <vs-chip @click="remove(formI797, children.documents.formI797)" :name="'formI94RemoveSelected'+index" :key="formI797Value" v-if="formI797.status !== false" closable> {{ formI797.name }} </vs-chip>
                              </template>
                            </ul>
                          </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_approvalNoticeOfPrevH4')">
                            <div class="form_group">
                              <label class="form_label">{{'approvalNoticeOfPrevH4' | formatdoctype }}</label> 
                              <file-upload :disabled="true" v-model="children.documents.formI797" class="file-upload-input" 
                                accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  :name="'chilFormI797'+index" data-vv-as="Form I-797" :multiple="true"
                                  @input="upload(children.documents.formI797, index)" >
                                  <img class="file-icon" src="@/assets/images/main/file-upload.svg">
                                  Upload 
                                </file-upload>
                                <span class="text-danger text-sm"
                                  v-show="errors.has('chilFormI797'+index)">{{ errors.first('chilFormI797'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <template  v-for="(formI797, formI797Value) in children.documents.formI797">
                              <vs-chip @click="remove(formI797, children.documents.formI797)" :name="'formI94RemoveSelected'+index" :key="formI797Value" v-if="formI797.status !== false" closable> {{ formI797.name }} </vs-chip>
                              </template>
                            </ul>
                          </div>

                        <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_birth_certificate')" >
                          <div class="form_group">
                            <label class="form_label">Birth Certificate</label>
                            <file-upload :disabled="true" v-model="children.documents.birthCertificate" class="file-upload-input"
                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              :name="'childBirthCertificate'+index" data-vv-as="Birth Certificate"
                              :multiple="true" @input="upload(children.documents.birthCertificate, index)" >
                              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
                            </file-upload>
                            <span class="text-danger text-sm"
                              v-show="errors.has('childBirthCertificate'+index)">{{ errors.first('childBirthCertificate'+index) }}</span>
                          </div>
                            <ul  class="uploaded-list">
                              <template v-for="(birthCertificate, birthCertificateValue) in children.documents.birthCertificate">
                              <vs-chip @click="remove(birthCertificate, children.documents.birthCertificate)" :name="'birthCertificateRemoveSelected'+index"  :key="birthCertificateValue" v-if="birthCertificate.status !== false" closable> {{ birthCertificate.name }} </vs-chip>
                              </template>
                            </ul>
                        </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_approval_notice')" >
                            <div class="form_group">
                            <label class="form_label">Approval Notice</label>
                            <file-upload :disabled="true" v-model="children.documents.approvalNotice" class="file-upload-input"
                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              :name="'approval_notice'+index" data-vv-as="Birth Certificate"
                              :multiple="true" @input="upload(children.documents.approvalNotice, index)" >
                              <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload 
                            </file-upload>
                            <span class="text-danger text-sm"
                              v-show="errors.has('childother'+index)">{{ errors.first('childother'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <template v-for="(approvalNotice, birthCertificateValue) in children.documents.approvalNotice">
                              <vs-chip @click="remove(approvalNotice, children.documents.approvalNotice)" :name="'birthCertificateRemoveSelected'+index"  :key="birthCertificateValue" v-if="approvalNotice.status !== false" closable> {{ approvalNotice.name }} </vs-chip>
                              </template>
                            </ul>
                          </div>
                          <div class="vx-col w-full marb20" v-if="checkTemplateField('child_docs_other')">
                            <div class="form_group">
                              <label class="form_label">Other documents, if any</label>
                              <file-upload :disabled="true" v-model="children.documents.other" class="file-upload-input"
                              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                :name="'childother'+index" data-vv-as="Birth Certificate"
                                :multiple="true" @input="upload(children.documents.other, index)" >
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg"> Upload
                              </file-upload>
                              <span class="text-danger text-sm"
                                v-show="errors.has('childother'+index)">{{ errors.first('childother'+index) }}</span>
                            </div>
                            <ul  class="uploaded-list">
                              <template  v-for="(other, indx) in children.documents.other">
                              <vs-chip @click="remove(other, children.documents.other)" :name="'birthCertificateRemoveSelected'+indx" :key="indx" v-if="other.status !== false" closable> {{ other.name }} </vs-chip>
                              </template>
                            </ul>
                          </div>


                        </div>
                      </div>
                    </vs-col>
                </template>
                </div>


             <vs-col v-if="checkTemplateField('addMoreChild')" class="m-auto float-none" vs-type="flex" vs-align="center" vs-sm="12">
                <a  class="add-more mt-5 ml-0 marb20" type="filled">
                  <span>+</span> Add Child
                </a>
              </vs-col> 
              </div>
               </template> 
            </form>
        </div> 
  </div> 


  <vs-collapse accordion >
    
    
    
</vs-collapse>
   
</div>
</template>
<script>
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import Datepicker from "vuejs-datepicker-inv";
  import moment from 'moment'
  import PhoneMaskInput from "vue-phone-mask-input";
  import JQuery from 'jquery';
  import { TheMask } from 'vue-the-mask';
  import FileUpload from "vue-upload-component/src"; 
  import _ from "lodash";

  export default {
    // balu data
    props:{
      templateId:{
        default:''
      }
    },
    data() {
      return {
        editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
        qloaded:false,
        currentroute:this.$route.params.itemId,
        selectedcountryOfBirth:[],
        selectedcitizenship:[],
        salaryOfferedType: [],
        resumeDocs: [],
        educationDocs: [],
        experienceDocs: [],
        insNoticeDocs: [],
        passportVisaI94Docs: [],
        formI20Docs: [],
        I797NoticeofApprovalforI140:[],
        socialSecurityCardAndProfLicenseDocs: [],
        childDocumentArray: [{
          childvisa: [],
          childpassport: [],
          childformI94: [],
          childbirthCertificate: [],
        }],
        childvisa: [],
        childpassport: [],
        childformI94: [],
        childbirthCertificate: [],
        visaDocuments: [],
        formI94: [],
        formI797Docs: [],
        marriageCertificateDocs: [],
        birthCertificate: [],
        // openDate: new Date().setFullYear(new Date().getFullYear() - 18),
        startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
        startBeneficiaryDateEntered: new Date().setFullYear(new Date().getFullYear() - 7),
        SuccessQuestionnaire: false,
        formerrors: {
          msg: ""
        },
        petition: [],
        beneficiaryInfo: {
          firstName: '',
          lastName:'',
          dateOfBirth: '',
          email: '',
          gender: null,
          maritalStatus: null,
          education: {
            highestDegree: "",
            majorFieldOfStudy: ""
          },
          address: {},
          iAmFromUS:'true',
          hasI140ImmPetitionFiled: true,
          SSN: ''
        },
        clientInfo: {
          address: {}
        },
        dependentsInfo: {
          spouse: {
            email:'',
            phoneNumber:'',
            phoneCountryCode:"+1",
            h4Required: true,
            h4EADRequired: null,
            lastArrivalDate:null,
            statusExpiryDate:null,
            physicalAddress: {

            },
            documents: {
              passport: [],
              visa: [],
              formI94: [],
              formI797: [],
              marriageCertificate: [],
              birthCertificate: [],
              other:[]
            }
          },
          childrens: [{
            documents: {
              passport: [],
              visa: [],
              formI94: [],
              birthCertificate: [],
              other:[]
            }
          }]
        },
        documents: {
          resume: [],
          education: [],
          expLetters: [],
          INSNotices: [],
          passportVisaI94: [],
          formI20: [],
          socialSecurityCardAndProfLicense: [],
          I140ApprovalNotice:[],
          payStubs:[],
          offerLetter:[],
          clientLetter:[],
          vendorLetter:[],
          msa:[],
          po:[], 
          other:[],
           },
        bncountryModel: [],
        checkCountry: false,
        countries: [],
        states: [],
        clientstates: [],
        stateModel: [],
        locations: [],
        locationModel: [],
        marital_statuses: [],
        education_types: [],
        visastatuses: [],
        clientcountryModel: [],
        clientstateModel: [],
        clientlocationModel: [],
        clientlocations: [],
        spousecountryModel: [],
        suposestates:[],
        souuselocations:[],
        spouseaddresscountryModel:null,
        spouseaddressstateModel:null,
        spouseaddresslocationModel:null,

        chiildcountryModel: [],
        clientInfo_salaryFrequency_Details:[],
        priorstay: {
          enteredDate: null,
          departedDate: null,
          visaStatus: null
        },
        priorPeriodOfStayInUS: [],
        childrensarray: [],
        children: [{
          "h4Required": true,
          "firstName": null,
          "middleName": null,
          "lastName": null,
          "dateOfBirth": null,
          "countryOfBirth": null,
          "selectedcountryOfBirth":null,
          "selectedcitizenship":null,
          "passportNumber": null,
          "passportExpiryDate": null,
          "I94": null,
          "visaIssuedDate": null,
          "currentStatus": null,
          "statusExpiryDate": null,
          "documents": {
          }
        }],
        countrySelected: '',
        countryOfCitizenshipSelected: '',
        latestPetition: '',

         //Cinfiguration 
        beneficiary: {
          first_name: false,
          middle_name: false,
          last_name:false,
          email: false,
          gender: false,
          dob:false,
          marital_status:false,
          cell_phone_number:false,
          home_phone_number:false,
          education: {
            highest_degree: false,
            major_field_of_study: false
          },
          address: {
            iam_notfrom_us:false,
            iam_from_us:false,
            beneficiary_address_line1:false,
            beneficiary_address_line2:false,
            beneficiary_address_country:false,
            beneficiary_address_state:false,
            beneficiary_address_city:false,
            beneficiary_address_zipcode:false,
          },
          hasI140ImmPetitionFiled: false,
          SSN: false,
          consulateNotifyAddress:false,
          docs_i140_approval_notice:false,
          documents:{
             docs_resume:false,
            docs_education:false,
            docs_exp_letters:false,
            docs_ins_notices:false,
            docs_passport_visa_i94:false,
            docs_form_i20_ead:false,
            docs_ssc_licence:false,
            docs_paystubs:false,
            docs_offer_letters:false,
            docs_client_letters:false,
            docs_vendor_letters:false,
            docs_msa:false,
            docs_po:false,
            docs_other:false

          },
         
        },
         spouse:{ 
            h4Required:false,
            spouse_h4_ead_required:false,
            spouse_first_name:false,
            spouse_middle_name:false,
            spouse_email:false,
            spouse_phone_number:false,
            spouse_dob:false,
            spouse_cob:false,
            spouse_passport_number:false,
            spouse_passport_expiry_date:false,
            spouse_i94:false,
            spouse_country_of_citizenship:false,
            spouse_current_status:false,
            spouse_status_expiry_date:false,
            spouse_ssn:false,
            spouse_date_of_last_arrival:false,
            addMoreChild:false,
            address: {
           
            spouse_address_line1:false,
            spouse_address_line2:false,
            spouse_address_country:false,
            spouse_address_state:false,
            spouse_address_city:false,
            spouse_address_zipcode:false,
          },
          documents:{
            "spouse_docs_passport": false, 
            "spouse_docs_visa": false,
            "spouse_docs_formi94": false,
            "spouse_docs_form_i797": false,
            "spouse_docs_mrg_certificate": false,
            "spouse_docs_other": false,
            "spouse_docs_noticeOfApprovalOfH1Status":false,
            "spouse_docs_approvalNoticeOfPrevH4":false


          }

          },
         children:{
            h4Required:false,
            child_first_name: false,
            child_middle_name: false,
            child_last_name:false,
            child_email: false,
            gender: false,
            dob:false,
            child_dob:false,
            child_cob:false,
            child_gender:false,
            child_passport_number:false,
            child_passport_expiry_date:false,
            child_i94:false,
            child_country_of_citizenship:false,
            child_current_status:false,
            child_marital_status:false,
            child_status_expiry_date:false,
            documents:{
               "child_docs_passport": false, 
               "child_docs_visa": false,
                "child_docs_form_i94": false,
               "child_docs_birth_certificate": false,
               "child_docs_approval_notice": false,
               "child_docs_photo":false,
               "child_docs_other":false,
               child_docs_approvalNoticeOfPrevH4:false,

            }

          },  
        questionnaireConfigData:{ name:'' , questionnaireId:'',  fields:[], sections:[]  },
        configId:null,
        configDetails:{"fields":[]},
        activatePopUp:false
      };
    },
    methods: {
      
      
      activateTemplate(){
        let postData = {questionnaireId:this.configId ,"active":true};
        this.$store.dispatch("commonAction" ,{"data":postData , "path":"/questionnaire/manage-active-status"})
        .then((res)=>{
          this.activatePopUp = false;
          this.showToster({message:res.message ,isError:false});
          this.getConfigDetails();

        })
        .catch((err)=>{

           this.showToster({message:err ,isError:true});
        })
      },
      setSpouseZipcode(){
        if(!this.dependentsInfo.spouse.physicalAddress.zipcode && this.beneficiaryInfo.address.zipcode){
          this.dependentsInfo.spouse.physicalAddress.zipcode   = this.beneficiaryInfo.address.zipcode
        }
      },
      setDependentsInfoAddress(isStreetAddress=true){
       
        if(isStreetAddress && this.beneficiaryInfo.address.line2 !='' &&  !this.dependentsInfo.spouse.physicalAddress.line2){
           this.dependentsInfo.spouse.physicalAddress.line2 = this.beneficiaryInfo.address.line2
         
           
        }

        if(!isStreetAddress && this.beneficiaryInfo.address.line1 !='' &&  !this.dependentsInfo.spouse.physicalAddress.line1){
           this.dependentsInfo.spouse.physicalAddress.line1 = this.beneficiaryInfo.address.line1;
        }
        
         },
      assignHomePhonenumber(){
        //beneficiaryInfo.cellPhoneNumber  beneficiaryInfo.homePhoneNumber
       // this.beneficiaryInfo['homePhoneNumber'] = this.beneficiaryInfo['cellPhoneNumber']
       // alert(this.beneficiaryInfo.homePhoneNumber);
      },
      setH4EADValue(h4, value) {
        this.dependentsInfo.spouse.h4EADRequired = (h4) ? value : null;
      },
      setDefaultcountry(){
        this.bncountryModel = {
          _id: "5db7f7409419e34350f11024",
          id: 231,
          name: "United States"
        },
        this.selectCountry(this.bncountryModel);


 

      },
      isDisabled(model) {
        if (model && model.length == 1) return false;
        return true;
      },
      acceptNumber() {
        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      },
      selectLocation(option) {
        this.beneficiaryInfo.address.locationId = option.id;
       

       
             this.dependentsInfo.spouse.physicalAddress.locationId =option.id;
             this.spouseaddresslocationModel = option;
              this.getSuposeLocation();
        
       
        


      },
      selectclientLocation(option) {
        this.clientInfo.address.locationId = option.id;
      },
      selectclientState(option) {
        this.clientInfo.address.stateId = option.id;
        this.clientlocationModel = [];
        this.getclientLocation();
      },
      selectclientCountry(option) {
        this.clientInfo.address.countryId = option.id;
        this.getclientStates();

      },

      
      selectspouseaddresstLocation(option) {
        this.dependentsInfo.spouse.physicalAddress.locationId = option.id;
      },
      selectspouseaddressState(option) {
        this.dependentsInfo.spouse.physicalAddress.stateId = option.id;
       // this.spouseaddresslocationModel = [];
        this.getSuposeLocation();
      },
      selectspouseaddressCountry(option) {
        this.dependentsInfo.spouse.physicalAddress.countryId = option.id;
        this.getSuposeStates();

      },

      selectState(option) {
        this.beneficiaryInfo.address.stateId = option.id;
        this.locationModel = [];
        this.getLocation();

     
        this.spouseaddressstateModel   = option;
        this.dependentsInfo.spouse.physicalAddress.stateId = option.id;
        this.getSuposeLocation();
    
        

        
        
      },
      selectCountry(option) {
        this.beneficiaryInfo.address.countryId = option.id;
        this.getStates();

        
          this.spouseaddresscountryModel = option;
          this.dependentsInfo.spouse.physicalAddress.countryId = option.id;
          this.getSuposeStates();
          

        

      },
      getclientStates() {
        this.$store
          .dispatch("getstates", this.clientInfo.address.countryId)
          .then(response => {
            this.clientstates = response;

            

          });

      },
      getStates() {
        this.$store
          .dispatch("getstates", this.beneficiaryInfo.address.countryId)
          .then(response => {
            this.states = response; 
          });
      },
      getclientLocation() {
        var obj = {
          stateId: this.clientInfo.address.stateId,
          countryId: this.clientInfo.address.countryId
        };

        this.$store.dispatch("getlocations", obj).then(response => {
          this.clientlocations = response;

          if(!this.spouseaddresslocationModel){
            this.spouseaddresslocationModel =this.locationModel
            this.selectspouseaddresstLocation(this.spouseaddresslocationModel)
          }

        });
      },
      getLocation() {
        var obj = {
          stateId: this.beneficiaryInfo.address.stateId,
          countryId: this.beneficiaryInfo.address.countryId
        };

        this.$store.dispatch("getlocations", obj).then(response => {
          this.locations = response;
        });
      },
     
     getSuposeStates() {
        this.$store
          .dispatch("getstates", this.dependentsInfo.spouse.physicalAddress.countryId)
          .then(response => {
            this.suposestates = response;
            

            if(this.spouseaddressstateModel !=null){
              this.spouseaddressstateModel = this.stateModel;
              this.selectspouseaddressState(this.spouseaddressstateModel);

            }

          });

      },
     getSuposeLocation() {
        var obj = {
          stateId: this.dependentsInfo.spouse.physicalAddress.stateId,
          countryId: this.dependentsInfo.spouse.physicalAddress.countryId
        };

        this.$store.dispatch("getlocations", obj).then(response => {
          this.souuselocations = response;

          // if(!this.spouseaddresslocationModel){
          //   this.spouseaddresslocationModel =this.locationModel
          //   this.selectspouseaddresstLocation(this.spouseaddresslocationModel)
          // }

        });
      },
     
     beforeTabSwitch() {
        
         return this.validateStep("beneficiaryInfoform");
        // return true;
      },
      beforeClient() {
        return this.validateStep("clientInfoform");
        // return true;
      },
      beforeDependents() {
      //  this.dependentsInfo.childrens = this.childrensarray; 

        Object.assign(this.dependentsInfo.childrens,this.childrensarray)
        
        
        //  return true;
         return this.validateStep("dependentsInfoform");
      },
      async validateStep(step) {
        let result = await this.$validator.validateAll(step).then(result => {
          return result;
        });
         result = true;
        if (result) {
          this.$validator.reset();
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        } else {
          const $ = JQuery;
          const firstField = Object.keys(this.errors.collect())[0];
          const ele = $('[name=' + firstField + ']').parents('.vx-col');
          $('html, body').animate({ scrollTop: ele.offset().top }, 2000);
        }
        return result;
      },
      setGender(item) {
        this.beneficiaryInfo.gender = item;
      },
      addpriorstay: function () {
        this.priorstay = {
          enteredDate: null,
          departedDate: null,
          visaStatus: null
        }
        this.priorPeriodOfStayInUS.push(this.priorstay);
      },
      removepriorstay: function (index) {
        Vue.delete(this.priorPeriodOfStayInUS, index)
      },
      addchildren: function () {
        this.children = {
          "h4Required": true,
          "firstName": null,
          "middleName": null,
          "lastName": null,
          "dateOfBirth": null,
          "countryOfBirth": null,
          "passportNumber": null,
          "passportExpiryDate": null,
          "I94": null,
          "visaIssuedDate": null,
          "currentStatus": null,
          "statusExpiryDate": null,
          "documents": {
            "passport": [],
            "visa": [],
            "FormI94": [],
            "formI797":[],
            "birthCertificate": [],
            "approvalNotice":[],
            "other":[]
          }
        },
        this.childrensarray.push(this.children);
      },
      removechildren: function (index) {
        Vue.delete(this.childrensarray, index)
        return false;
      },
      reloadthePage() {
          let routeTest = this.$route.params.itemId
          this.$router.push({ name: 'petition-details', params: { routeTest } })
      },
      formSubmitted() {
        /*
        var postpetition = {
          petitionId: this.$route.params.itemId,
          questionnaireFilled: true,
          userName: this.$store.state.user.name,
          typeName: this.petition.typeDetails.name,
          subTypeName: this.petition.subTypeDetails.name,
          action: "SUBMIT_QUESTIONNAIRE",
          currentDate: moment().format('YYYY-MM-DD'),
          beneficiaryInfo: this.beneficiaryInfo,
          dependentsInfo: this.dependentsInfo,
          clientInfo: this.clientInfo,
          documents: this.documents
        }
        postpetition.beneficiaryInfo.priorPeriodOfStayInUS = this.priorPeriodOfStayInUS;
        this.$store
          .dispatch("petitioner/petitionupdate", postpetition)
          .then(response => {

            if (response.error) {
              Object.assign(this.formerrors, {
                msg: response.error.message
              });
            } else {
              this.$vs.notify({
                title: "Success",
                text: response.message
              });
              this.SuccessQuestionnaire = true;

              document.addEventListener('click', this.reloadthePage);
            }
          });
     */
     },
      upload(model) {
        let formData = new FormData();
        let mapper = model.map(item => item = {
          name: item.name,
          file: (item.file) ? item.file : null,
          url: (item.url) ? item.url : "",
          status: (item.status === false || item.status === true) ? item.status : true,
          mimetype: (item.type) ? item.type : item.mimetype
        });
        if(mapper.length > 0){
          // mapper.forEach((doc, index)=> {
          //   formData.append('files', doc.file);
          //   formData.append('secureType', 'private');
          //   this.$store.dispatch('uploadS3File', formData).then(response=> {
          //     response.data.result.forEach(urlGenerated=> {
          //       doc.url = urlGenerated;
          //       delete doc.file;
          //       mapper[index] = doc;
          //     })
          //   });
          // })
          model.splice(0, mapper.length, ...mapper);
        }
      },
      remove(item, type) {
        item.status = false;
        type[type.indexOf(item)] = item;
        return false;
      },
      selectchildCountry(option,id){
      this.childrensarray[id].countryOfBirth = option.id;
      },
       selectchildCitizenship(option,id){
      this.childrensarray[id].countryOfCitizenship = option.id;
      },

      
      selectspouseCountry(option) {
        this.dependentsInfo.spouse.countryOfBirth = option.id;
      },
          selectspousecountryOfCitizenship(option) {
        this.dependentsInfo.spouse.countryOfCitizenship = option.id;
      },
      getSalary_frequencies() {
        this.$store
          .dispatch("get_salary_frequencies", this.clientInfo.address.countryId)
          .then(response => {
            this.salaryOfferedType = response;
          });
      },
      getLatestPetition() {
        this.$store
        .dispatch("getlatestpetition", this.petition.userId)
        .then(response=> {
          this.$store
          .dispatch("getpetition", response[0]._id)
          .then(details=> {
            this.latestPetition = details.data.result;
            if(this.latestPetition.beneficiaryInfo) {
              this.beneficiaryInfo = this.latestPetition.beneficiaryInfo;
              this.documents = this.latestPetition.documents;
              if(this.beneficiaryInfo && this.beneficiaryInfo.address && this.beneficiaryInfo.address.countryDetails) {
                this.selectCountry(this.beneficiaryInfo.address.countryDetails);
                this.selectState(this.beneficiaryInfo.address.stateDetails);
                this.bncountryModel = this.beneficiaryInfo.address.countryDetails;
                this.stateModel = this.beneficiaryInfo.address.stateDetails;
                this.locationModel =this.beneficiaryInfo.address.locationDetails;
              }
              this.priorPeriodOfStayInUS = this.beneficiaryInfo.priorPeriodOfStayInUS;
            }
          })  
        })
      },
   
     
      checkTemplateField(checkKey=''){
        let return_value = false;
        if( checkKey !='' && _.has(this.configDetails,"fields") ){
          checkKey = checkKey.toLowerCase();
          return_value = _.findIndex( this.configDetails.fields ,(el)=>{ return el.toLowerCase() ==checkKey })>-1?true:false;
        }
        /*
        if(checkKey =="iam_from_us"){
          this.beneficiaryInfo.iAmFromUS =true;

        }
        if(checkKey =="iam_notfrom_us"){
          this.beneficiaryInfo.iAmFromUS =false;

        }
        */
        return return_value;
      },
      getAllCountryes(){
         this.$store.dispatch("getcountries").then(response => {
        this.countries = response;
        this.clientcountryModel = {
              _id: "5db7f7409419e34350f11024",
              id: 231,
              name: "United States"
            },

         this.selectclientCountry(this.clientcountryModel);

         

      });
     
      },
       mapData(){
        let dataVeriables = ['beneficiary' ,'spouse' ,'children'];
        _.forEach(dataVeriables ,(ver)=>{
            _.forEach(this[ver] ,(item ,fld )=>{
                if(typeof item == "boolean"){
                  
                  if(this.configDetails['fields'].indexOf(fld) >-1){

                    
                    
                    try{
                      this[ver][fld] =true;
                      this.questionnaireConfigData.fields.push(fld);
                    }catch(err){}
                  }

                    
                      
                }else{

                  _.forEach(item ,( subitem ,fldVal)=>{
                      if(typeof subitem == "boolean"){
                              if(this.configDetails['fields'].indexOf(fldVal) >-1){
                                  try{
                                    this[ver][fld][fldVal] =true;
                                     this.questionnaireConfigData.fields.push(fldVal);
                                  }catch(err){}
                                    
                              }
                              
                      }
                  });
                  
                }
            });
        });
        this.qloaded = true;
      },
      getConfigDetails(){
        let postData = {questionnaireId:this.configId};
        this.$store.dispatch("commonAction" ,{  "data":postData ,"path":"/questionnaire/details" })
        .then((res)=>{
          //alert(JSON.stringify(res.name));
          this.configDetails = res;
         // this.configDetails['fields'] =[ "first_name","middele_name","last_name","email","gender"];
          this.questionnaireConfigData['name'] = res.name
           this.questionnaireConfigData['questionnaireId'] = this.configId;
          //questionnaireConfigData:{ name:'' , questionnaireId:'',  fields:[], sections:[]  },
          this.mapData();

        })

      },
   },
    mounted() {
      
    JQuery('#btnSidebarToggler').click();
     this.configId = this.$route.params.id;
     if(this.templateId){
       this.configId = this.templateId;
     }
    this.getConfigDetails();
  // this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true);
// this.$store.dispatch('updateSidebarWidth', 'reduced')
     
      this.priorPeriodOfStayInUS = [
        {
          enteredDate: null,
          departedDate: null,
          visaStatus: null
        }
      ];
      this.childrensarray = [
        {
          "h4Required": true,
          "firstName": null,
          "middleName": null,
          "lastName": null,
          "dateOfBirth": null,
          "countryOfBirth": null,
          "passportNumber": null,
          "passportExpiryDate": null,
          "I94": null,
          "visaIssuedDate": null,
          "currentStatus": null,
          "statusExpiryDate": null,
          "documents": {
            "passport": [],
            "visa": [],
            "formI94": [],
            "birthCertificate": [],
            "other":[]
          }
        }
      ];
      
     
      
      setTimeout(function(){
           window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })

                setTimeout(()=>{
                JQuery('.questionary_accordion').find('input, textarea,  select, radio').attr('disabled','disabled');

                } ,100)

      },1500)
          
     
     
     
    },
    components: {
      FormWizard,
      TabContent,
      Datepicker,
      PhoneMaskInput,
      TheMask,
      FileUpload, 
    },
    watch: {
      'beneficiaryInfo.iAmFromUS': function(value) {
        if(value === 'true') {
          
          this.checkCountry = false;
          this.setDefaultcountry();
        } else {
          this.checkCountry = true;
        }
      },
      'maritalStatusOpen': function(value) {} 
    },
  };
</script>